import {
  Component,
  OnInit,
  Inject,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  Optional,
  QueryList,
  ViewChildren,
  Input,
} from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AppointmentService } from "./appointment.service";
import { UserTypeList } from "../dashboard/Models/usertypelist.model";
import { DashboardService } from "../dashboard/dashboard.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { AuthService } from "app/auth/auth.service";
import { DatePipe } from "@angular/common";
import { AddappointmentComponent } from "./addappointment/addappointment.component";
import { addppointmentservice } from "./addappointment/addappointment.service";
import { HttpClient } from "@angular/common/http";
import { SiteloaderComponent } from "app/auth/siteloader/siteloader.component";

import { cancelModel } from "app/opdvisits/cancelModel.model";
import { Router } from "@angular/router";

import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "app/shared/language.service";
import { TransferAppointmentComponent } from "./transfer-appointment/transfer-appointment.component";
import { BillingserviceService } from "app/billing/billingService.service";
import { ExportService } from "app/reports/services/export.service";
import { PatientdocsComponent } from "app/table-list/patientdocs/patientdocs.component";
import { Observable, of } from "rxjs";
import { map, startWith, take, takeUntil } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { SelectionModel } from "@angular/cdk/collections";
import { SearchDialogComponent } from "app/table-list/Searchdialog/SearchDialoag.component";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatRadioChange } from "@angular/material/radio";
import { AppointmentColorModel } from "app/opdvisits/Models/appointment_color.model";
import { HolidayMasterModel } from "app/opdvisits/Models/holiday_master.model";
import { PatientFieldsModel } from "app/table-list/Models/patient_mendatory_fields_config.model";
import * as moment from "moment";
import { Subject } from "rxjs";


export interface Scheduletype {
  pkScheduleTypeId: number;
  scheduleType: string;
  isActive: boolean;
  pkSynchId: number;
  tbldoctoropdschedulemaster: any;
}
export interface IGetAppListData {
  BookingDate: string;
  AppDate: string;
  AppTime: string;
  DoctorName: string;
  PatientId: number;
  PatientName: string;
  ContactNo: string;
  IsCancelled: string;
  ReferredBy: string;
  AppType: string;
  AppTakenBy: string;
  GivenBy: string;
  ModifyBy: string;
}
export interface IConsListData {
  pkTransId: number;
  fK_RegID: number;
  age: number;
  mobileNo: number;
  bookingDate: string;
  surgeryDate: string;
  surgeryTime: string;
  reportingDate: string;
  reportingTime: string;
  statusId: number;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "app-upgrade",
  templateUrl: "./upgrade.component.html",
  styleUrls: ["./upgrade.component.scss"],
})
export class UpgradeComponent implements OnInit {

  @ViewChild("defaultauto", { static: false })
  @ViewChildren('holidayinput') holidayinputRef: QueryList<ElementRef>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  private defaultautoRef: ElementRef;
  private xpandStatus: boolean = false;
  private selectedDate: any = this.authService.getServerDate; // = new Date('2019/11/01');
  private selectefromdate:any = this.authService.getServerDate;
  private fromDateDrSummery: any; // = new Date('2019/11/01');
  private toDateDrSummery: any;
  private selectedAppListDate: any = this.authService.getServerDate;
  private selectedLink: string = "Doctor";
  private Doctor_time_info = [];
  doctorlist: any = [];
  //added by sachin
  // private morning_schedule = [];
  // private afternoon_schedule = [];
  // private evening_schedule = [];
  // private night_schedule = [];
  private current_schedule = 0;
  private selecteddoctor: string;
  private eventcheck: boolean = false;
  private GetAppListData = [];
  private ConsListData = [];
  private GetAppListDataOnline = [];
  private getAppListCount: any;
  private branchName;
  private appDate;
  private drId;
  private ApptStatus: string = "";
  private ReportingStatus;
  private SurgeryStatus;
  private CancelStatus;
  private AllPatient;
  private times: string;
  private AllPatientCons;
  private PtId;
  private TotalApp: number = 0;
  private ReportedApp: number = 0;
  private CancelledApp: number = 0;
  private isBlockApp: number = 0;
  private isConfirmApp: number = 0;
  private apptSlotLimit;
  private total_appointment_count: number;
  private blockTime: string = "";
  private today: any = this.authService.getServerDate;
  private appId;
  private timevalues: cancelModel[] = [];
  private timeSingleValue: cancelModel = {};
  private appointmentColorobj: AppointmentColorModel = {}
  private apId: number = 0;
  private chkSlot: number = 0;
  private RealTime: number = 0;
  private ApptTime: number = 0;
  private filterreferd: any;
  private checkgender: boolean = true;
  private filteredItems: Observable<any[]>;
  private inputControl = new FormControl();
  //baseUrl = "http://49.50.108.154:7575/api/";
  @ViewChild("panel") panel;
  private dataSource = new MatTableDataSource<UserTypeList>();
  branchColumns: string[] = [
    "branchName",
    "branchCode",
    "address",
    "geoLocation",
    "contactNo",
  ];
  private branchdataSource = new MatTableDataSource<any>();
  private appdataSource = new MatTableDataSource<any>();
  private displayedColumns: string[] = [
    "select",
    "bookingDate",
    "apptDate",
    "appTime",
    "doctorName",
    "patientId",
    "patientName",
    "contactNo",
    "cn",
    "referredby",
    "apptType",
    "apptTakenBy",
    "givenBy",
    "modifyBy",
    "tempID",
    "remarks",
  ];
  private selection = new SelectionModel<any>(true, []);
  // private yearList: any;
  // private yearListOnline: any;
  // private DayAndDateList: string;
  // private DayAndDateListOnline: string;
  private startAt: any = new Date(this.authService.localDate);
  // private minDate: any = new Date();
  private maxDate: any = new Date(
    new Date(this.authService.getServerDate).setMonth(new Date().getMonth() + 6)
  );
  private year: any;
  // private DayAndDate: string;
  private selectisBlock: boolean;
  private selectCancelled: boolean;
  private branchlist: any;
  private appList: any;
  private appListdata: any;
  private reportingData: any;
  private cancellistdata: any;
  private apptbranchid: number;
  private apptPatientId: any;
  private getBranceId: any;
  private getBranceId1: any;
  private getBranceId2: any;
  private getBranceId3: any;
  private getBranceId4: any;
  private getBranceId5: any;
  private HighlightRow: any;
  private filteredDoctorArray: Observable<any[]>;
  private DoctorCtrl = new FormControl();
  private filteredDoctorArray1: Observable<any[]>;
  private DoctorCtrl1 = new FormControl();
  private filteredDoctorArray2: Observable<any[]>;
  private DoctorCtrl2 = new FormControl();
  private filteredDoctorArray3: Observable<any[]>;
  private DoctorCtrl3 = new FormControl();
  private filteredDoctorArray4: Observable<any[]>;
  private DoctorCtrl4 = new FormControl();
  private filteredreportArray: Observable<any[]>;
  private reportCtrl = new FormControl();
  private filteredcancelArray: Observable<any[]>;
  private cancelCtrl = new FormControl();
  private filteredtemplateArray: Observable<any[]>;
  private templateCtrl = new FormControl();
  private templatelist: any;
  private branchCtrl = new FormControl();
  private filteredbranchArray: Observable<any[]>;
  private branchCtrl1 = new FormControl();
  private filteredbranchArray1: Observable<any[]>;
  private yearsCtrl = new FormControl();
  private filteredyearsArray: Observable<any[]>;
  private filteredAdvisedDoctorArray: Observable<any[]>;
  private filteredCounArray: Observable<any[]>;
  private consDrControl = new FormControl();
  private consControl = new FormControl();

  private seletedTemp: any;
  private selectBranch: any;
  private apptbranchname: any;
  private rescheduleapp: boolean;
  private rowdata: any;
  private resdoctorid: any;
  private restime: any;
  private resDate: any;
  private restypeId: any;
  private ongridReschedule: boolean;
  private onGridslotLimit: any;
  private user_validated = "";
  private slotcount: number;
  private addApptType: any;
  private oldappoitmentId: number = 0;
  private disabledappointment: boolean = false;
  private searchAppoitment: any;
  private searchDoctor: any;
  private doctortype: number = 6;
  private isopenaspopup: boolean = false;
  private selectedDoctorName: string = '';
  private selectedDoctorName2: string = '';
  private selectedDoctorName3: string = '';
  private selectedDoctorName4: string = '';
  private radioGroup1Value: string = '6';
  private radioGroup2Value: string = '6';
  private radioGroup3Value: string = '6';
  private radioGroup4Value: string = '6';



  setradio(e: string): void {
    this.selectedLink = e;
  }

  isSelected(name: string): boolean {
    if (!this.selectedLink) {
      return false;
    }

    return this.selectedLink === name;
  }

  private panelOpenState = false;
  private index: number;
  // MatPaginator Inputs
  private length = 100;
  private pageSize = 10;
  private pageSizeOptions: number[] = [5, 10, 25, 100];
  private checked = false;

  // MatPaginator Output
  private pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput
      .split(",")
      .map((str) => +str);
  }

  Doctor_Info: any[];
  selected: Date | null;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private opdvisitService: OpdVisitService,
    private translate: TranslateService,
    private langservice: LanguageService,
    private appservice: AppointmentService,
    private exportdata: ExportService,
    private router: Router,
    private addappservice: addppointmentservice,
    private dashboardService: DashboardService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private billingservice: BillingserviceService,
    private dialogRef: MatDialogRef<UpgradeComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.getBranceId = authService.Loggeduser.branchid;
    this.getBranceId1 = authService.Loggeduser.branchid;
    this.getBranceId2 = authService.Loggeduser.branchid;
    this.getBranceId3 = authService.Loggeduser.branchid;
    this.getBranceId4 = authService.Loggeduser.branchid;
    this.getBranceId5 = authService.Loggeduser.branchid;
    // this.current_schedule=this.appservice.current_schedule;
    // this.authService.getServertime();
    translate.addLangs(["en", "fr", "hi"]);
    // translate.setDefaultLang('hi');
    // this.langservice.setlang
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    } else {
      translate.setDefaultLang("en");
    }

    this.onSelect(this.selectedDate, 5);
    this.getchangedlanguage();
    if (data.isopenpopup) {
      this.isopenaspopup = data.isopenpopup;
    }
    this.getopdvistColor();
    this.dashboardService.moudletype
      .pipe(takeUntil(this.destroy$))
      .subscribe((quote) => {
        if (quote == 1) {
          this.onSelect(this.selectedDate, 5);
          this.ngOnInit();
        }
      });
  }

  getopdvistColor() {
    this.dashboardService.subscriptions = this.dashboardService.AppointmentCol().pipe(takeUntil(this.destroy$)).subscribe((item: any) => {
      if (item.length > 0) {
        const blockdata = item.filter(x => x.propertyName.toLowerCase() == 'total');
        const bookeddata = item.filter(x => x.propertyName.toLowerCase() == 'booked');
        const reporteddata = item.filter(x => x.propertyName.toLowerCase() == 'reported');
        const blockeddata = item.filter(x => x.propertyName.toLowerCase() == 'blocked');
        const cancelledata = item.filter(x => x.propertyName.toLowerCase() == 'cancelled');
        const completeslotdata = item.filter(x => x.propertyName.toLowerCase() == 'completeslot');
        if (blockdata.length > 0) {
          this.appointmentColorobj.totalAppointment = blockdata[0].propertyValue;
        } else {
          this.appointmentColorobj.totalAppointment = '#16c6f1';
        }
        if (bookeddata.length > 0) {
          this.appointmentColorobj.bookedAppointment = bookeddata[0].propertyValue;
        } else {
          this.appointmentColorobj.bookedAppointment = '#ebebeb';
        }
        if (reporteddata.length > 0) {
          this.appointmentColorobj.reportedAppointment = reporteddata[0].propertyValue;
        } else {
          this.appointmentColorobj.reportedAppointment = '#CAF6B8';
        }
        if (blockeddata.length > 0) {
          this.appointmentColorobj.blockedAppointment = blockeddata[0].propertyValue;
        } else {
          this.appointmentColorobj.blockedAppointment = '#998b8b';
        }
        if (cancelledata.length > 0) {
          this.appointmentColorobj.cancelledAppointment = cancelledata[0].propertyValue;
        } else {
          this.appointmentColorobj.cancelledAppointment = '#FFFF00';
        }
        if (completeslotdata.length > 0) {
          this.appointmentColorobj.completeslotAppointment = completeslotdata[0].propertyValue;
        } else {
          this.appointmentColorobj.completeslotAppointment = '#0D24EE';
        }
      } else {
        this.appointmentColorobj.blockedAppointment = '#998b8b';
        this.appointmentColorobj.cancelledAppointment = '#FFFF00';
        this.appointmentColorobj.totalAppointment = '#16c6f1';
        this.appointmentColorobj.reportedAppointment = '#CAF6B8';
        this.appointmentColorobj.completeslotAppointment = '#0D24EE';
        this.appointmentColorobj.bookedAppointment = '#ebebeb';
      }
    }, err => {
      this.dashboardService.openSnackBar("API Failed", "ok");
    })
  }
  closedialog() {
    this.dialogRef.close();
  }
  getchangedlanguage() {
    this.translate
      .get([
        "upgradeMsg.msg1",
        "upgradeMsg.msg2",
        "upgradeMsg.msg3",
        "upgradeMsg.msg4",
        "upgradeMsg.msg5",
        "upgradeMsg.msg6",
        "upgradeMsg.msg7",
        "upgradeMsg.msg8",
        "upgradeMsg.msg9",
        "upgradeMsg.msg10",
        "upgradeMsg.msg11",
        "upgradeMsg.msg12",
        "upgradeMsg.msg13",
        "upgradeMsg.msg14",
        "upgradeMsg.msg15",
        "upgradeMsg.msg16",
        "upgradeMsg.msg17",
        "upgradeMsg.msg18",
        "upgradeMsg.msg19",
        "upgradeMsg.msg20",
        "upgradeMsg.msg21",
        "upgradeMsg.msg22",
        "upgradeMsg.msg23",
        "upgradeMsg.msg24",
        "upgradeMsg.msg25",
        "upgradeMsg.msg26",
        "upgradeMsg.msg27",
        "upgradeMsg.msg28",
        "upgradeMsg.msg29",
        "upgradeMsg.msg30",
        "upgradeMsg.msg31",
        "upgradeMsg.msg32",
        "upgradeMsg.msg33",
        "upgradeMsg.msg34",
        "upgradeMsg.msg35",
        "upgradeMsg.msg36",
        "upgradeMsg.msg37",
        "upgradeMsg.msg38",
        "upgradeMsg.msg39",
        "upgradeMsg.msg40",
        "upgradeMsg.msg41",
        "upgradeMsg.msg42",
        "upgradeMsg.msg43",
        "Ok",
      ]).pipe(takeUntil(this.destroy$))
      .subscribe((x) => {
        this.authService.appointmentMsg = {};
        this.authService.appointmentMsg = x;
      });
  }

  applyFilter(keyvalue: any) {
    var foundValue = this.filterByValue(this.appservice.doctors, keyvalue);

    if (foundValue.length > 0 && keyvalue != "") {
      this.appservice.doctors = foundValue;
    } else {
      // this.getDoctorBrach();
    }
  }

  filterByValue(array, value) {
    return array.filter(
      (data) =>
        JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  takanonArray: any = [];
  getTakenon() {
    this.dashboardService.subscriptions = this.appservice.GetPopUpHelp("TAKENON").pipe(takeUntil(this.destroy$)).subscribe(
      (x: any) => {
        this.takanonArray = [];
        this.takanonArray = x.filter((item) => item.isActive == true);
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  istreeview: boolean = true;
  treeview(event: MatCheckboxChange) {
    this.istreeview = event.checked;
  }
  isemergency: boolean = false;
  emergencyAppt(event: MatCheckboxChange) {
    this.isemergency = event.checked;
    if (event.checked == true) {
      if (this.apptList.length > 0) {
        let emg = this.apptList.filter(
          (item) => item.apptType.toLowerCase() == "emergency"
        );
        if (emg.length > 0) {
          this.opdvisitService.apptdetail.fkApptTypeId = emg[0].apptTypeId;
        } else {
          this.opdvisitService.apptdetail.fkApptTypeId = null;
        }
      } else {
        this.opdvisitService.apptdetail.fkApptTypeId = null;
      }
    } else {
      if (this.apptList.length > 0) {
        this.opdvisitService.apptdetail.fkApptTypeId =
          this.apptList[0].apptTypeId;
      } else {
        this.opdvisitService.apptdetail.fkApptTypeId = null;
      }
    }
  }
  onSelectConsList(event,type) {
    debugger;
    if(type == 2){
      this.selectedDate = event.value;
      this.appservice.selectedDateList = event.value;
      this.appservice.selectedDate = this.datePipe.transform(this.selectedDate,"yyyy-MM-dd");
      this.appservice.selectedDateList = this.appservice.selectedDate;

    } else if ( type == 1){
      this.selectefromdate = event.value;
      this.appservice.selectfromdatelist = event.value;
      this.appservice.fromselectedDate = this.datePipe.transform(this.selectefromdate,"yyyy-MM-dd");
      this.appservice.selectfromdatelist = this.appservice.fromselectedDate;

       if ( this.appservice.selectedDateList &&  this.appservice.selectedDateList < this.appservice.fromselectedDate) {
         this.appservice.selectedDateList = null;
       }
    }
  }

  onSelect(event, type) {
    this.opdvisitService.timevalues = [];
    this.xpandStatus = false;

    // this.appservice.afternoon_schedule.length = 0;
    // this.appservice.morning_schedule.length = 0;
    // this.appservice.evening_schedule.length = 0;
    // this.appservice.night_schedule.length = 0;
    this.selectedDate = event;
    // this.opdvisitService.appservice.selectedDate=event;

    //const dateString = event.toDateString();
    //const dateValue = dateString.split(' ');
    // this.year = dateValue[3];
    // this.DayAndDate = dateValue[0] + ',' + ' ' + dateValue[1] + ' ' + dateValue[2];
    // this.appDate = dateValue;

    //this.appservice.selectedDate = this.year + "-" + dateValue[1] + '-' + dateValue[2];
    this.appservice.selectedDate = this.datePipe.transform(event, "yyyy-MM-dd");
    this.appDate = this.appservice.selectedDate;
    // this.opdvisitService.appservice.selectedDate = this.datePipe.transform(this.appservice.selectedDate, "yyyy-MM-dd")
    this.opdvisitService.appservice.selectedDate = this.appservice.selectedDate;
    if (parseInt(this.appservice.selectedDate) > 0) {
      if (parseInt(this.appservice.DoctorId) > 0) {
        // this._gethospital_total_appointments();
        // this.appservice.showRec(this.getBranceId);
        this.getDoctorBrach(this.getBranceId, type);
        this.getcolor(
          event.patientName,
          event.isBlock,
          event.isCancelled,
          event.isConfirm
        );
        //this.appservice.Doctor_time_info().subscribe(data=>this.Doctor_time_info= data)
        //this.appservice.Doctor_time_info().subscribe(data=>this.success_info_app(data),
        //err => this.failed_info_app(err));
      } else {
        alert(this.authService.appointmentMsg["upgradeMsg.msg1"]);
      }
    } else {
      alert(this.authService.appointmentMsg["upgradeMsg.msg2"]);
    }
    console.log(this.appservice.selectedDate);

    // this.panel.close();

  }
  success_info_app(data) {
    //  alert(this.total_appointment_count);
    this.Doctor_time_info = data;
    for (var val of data) {
      if (val.isConfirm == true) {
        this.ReportedApp = this.ReportedApp + 1;
      } else if (val.isCancelled == true) {
        this.CancelledApp = this.CancelledApp + 1;
      } else if (val.isBlock == true) {
        this.isBlockApp = this.isBlockApp + 1;
      } else if (val.isConfirm == false) {
        this.isConfirmApp = this.isConfirmApp + 1;
      }
    }
  }

  //branches changes //
  onOptionsSelected(event, type) {
    if (type == 0) {
      // let text = event.target.options[event.target.options.selectedIndex].text;
      // this.authService.Loggeduser.branchid = event;
      this.getBranceId = event;
      // this.authService.Loggeduser.branchname = text;
      //  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
      //  this.router.navigate(['/layout/Appointments']));
      // this.appservice.afternoon_schedule.length = 0;
      // this.appservice.morning_schedule.length = 0;
      // this.appservice.evening_schedule.length = 0;
      // this.appservice.night_schedule.length = 0;
      this.ReportedApp = 0;
      this.CancelledApp = 0;
      this.isBlockApp = 0;
      this.isConfirmApp = 0;
      this.TotalApp = 0;
      this.getDoctorBrach(event, type);
    } else if (type == 1) {
      this.getBranceId1 = event;
      this.getDoctorBrach(event, type);
    } else if (type == 2) {
      this.getBranceId2 = event;
      this.getDoctorBrach(event, type);
    } else if (type == 3) {
      this.getBranceId3 = event;
      this.getDoctorBrach(event, type);
    } else if (type == 4) {
      this.getBranceId4 = event;
      this.getDoctorBrach(event, type);
    }
  }
  failed_info_app(err) {
    //  console.log("");
    //  alert(this.total_appointment_count);
    //this.Doctor_time_info = data;
  }

  onSelectAppList(event) {
    this.selectedAppListDate = event.value;

    // const dateStringList = event.value.toDateString();
    // const dateValueList = dateStringList.split(' ');
    // this.yearList = dateValueList[3];
    // this.DayAndDateList = dateValueList[0] + ',' + ' ' + dateValueList[1] + ' ' + dateValueList[2];

    // this.appservice.selectedDateList = this.yearList + "-" + dateValueList[1] + '-' + dateValueList[2];
    this.appservice.selectedDateList = this.datePipe.transform(
      this.selectedAppListDate,
      "yyyy-MM-dd"
    );
    this.selectedAppListDate = this.appservice.selectedDateList;
    if (parseInt(this.appservice.selectedDateList) > 0) {
      // this.appservice.selectedDateList = this.datePipe.transform(this.appservice.selectedDateList, "yyyy-MM-dd")
      if (parseInt(this.appservice.DoctorId) > 0) {
        this.getcolor(
          event.patientName,
          event.isBlock,
          event.isCancelled,
          event.isConfirm
        );
        //  this.appservice.Doctor_time_info().subscribe(data=>this.Doctor_time_info= data)
        // this.appservice.Doctor_time_info().subscribe(data=>this.success_info_app(data),
        // err => this.failed_info_app(err));
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg1"],
          this.authService.appointmentMsg["Ok"]
        );

      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg2"],
        this.authService.appointmentMsg["Ok"]
      );

    }
  }

  blocMekAll() {
    let now = this.authService.localDate;
    var xHr = now.getHours(); //
    var xMin = now.getMinutes(); //
    var yTime = this.convertTo24Hour(this.slottime);
    if (
      Date.parse(
        this.datePipe.transform(this.today, "yyyy-MM-dd").toString()
      ) ==
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      let ApptX = yTime.split(":");
      this.RealTime = xHr * 60 + xMin;
      this.ApptTime = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);
      if (this.ApptTime < this.RealTime) {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg3"],
          this.authService.appointmentMsg["Ok"]
        );
        return;
      }
    }
    if (
      Date.parse(this.datePipe.transform(this.today, "yyyy-MM-dd").toString()) >
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg3"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }
    if (this.selectisBlock == true) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg4"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }

    document.getElementById("blockAppoitnmentModel").style.display = "block";
  }

  addblockReason() {
    this.opdvisitService.blockTimeValues.map(
      (item) => (item.reason = this.opdvisitService.blockTimeSingleValue.reason)
    );
    this.dashboardService.subscriptions = this.opdvisitService
      .appointmentBlock(this.opdvisitService.blockTimeValues).pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => this.success_blockAll_save(data),
        (err) => this.failed_blockAll_save(err)
      );
  }
  success_blockAll_save(data) {
    // this.blockTimeDetail.pkTranId = data;
    if (data.length == 1) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg5"],
        this.authService.appointmentMsg["Ok"]
      );
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg6"],
        this.authService.appointmentMsg["Ok"]
      );
    }
    this.opdvisitService.timevalues = [];
    this.opdvisitService.blockTimeValues = [];
    this.blockAppointmentReason();
    this.showRec();
  }
  failed_blockAll_save(err) {
    this.opdvisitService.timevalues = [];
    this.opdvisitService.blockTimeValues = [];
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //Release
  releaseMeAll() {
    this.opdvisitService.blockTimeValues.map(
      (item) => (item.reason = this.opdvisitService.blockTimeSingleValue.reason)
    );
    this.dashboardService.subscriptions = this.opdvisitService
      .relaseBlockAppoitment(this.opdvisitService.blockTimeValues).pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => this.success_releaseAll_save(data),
        (err) => this.failed_releaseAll_save(err)
      );
  }
  success_releaseAll_save(data) {
    // this.blockTimeDetail.pkTranId = data;
    if (data.length == 1) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg7"],
        this.authService.appointmentMsg["Ok"]
      );
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg8"],
        this.authService.appointmentMsg["Ok"]
      );
    }
    this.opdvisitService.blockTimeValues = [];
    this.opdvisitService.timevalues = [];
    this.releaseAppointmentReason();
    this.showRec();
  }
  failed_releaseAll_save(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  //
  blockbooleanmsg: boolean = false;
  BlockAll() {
    //alert("Length-"+this.opdvisitService.blockTimeValues.length);

    if (this.opdvisitService.blockTimeValues.length > 0) {
      this.blockbooleanmsg = false;
      if (this.opdvisitService.timeSingleValue.appId == 0) {
        this.blocMekAll();
        //this.selectMeALL();
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg9"],
          this.authService.appointmentMsg["Ok"]
        );
      }
    } else {
      if (this.appservice.docotrSlot.length > 0) {
        this.blockbooleanmsg = true;
        const checkblockapp = this.appservice.docotrSlot.filter(
          (item) => item.isConfirm != true
        );
        if (checkblockapp.length > 0) {
          this.opdvisitService.blockTimeValues = [];
          for (var i = 0; i < checkblockapp.length; i++) {
            this.opdvisitService.blockTimeSingleValue = {};
            this.opdvisitService.blockTimeSingleValue.apptTime =
              checkblockapp[i].time;
            this.opdvisitService.blockTimeSingleValue.fkBranchId =
              this.getBranceId;
            this.opdvisitService.blockTimeSingleValue.fkCreatedById =
              this.authService.Loggeduser.userid;
            this.opdvisitService.blockTimeSingleValue.isActive = "true";
            this.opdvisitService.blockTimeSingleValue.pkTranId = 0;
            this.opdvisitService.blockTimeSingleValue.fkDoctorId = parseInt(
              checkblockapp[i].doctorId
            );
            this.opdvisitService.blockTimeSingleValue.apptDate =
              this.datePipe.transform(
                checkblockapp[i].scheduleDate,
                "yyyy-MM-dd"
              );
            this.opdvisitService.blockTimeSingleValue.apptTime =
              this.convertTo24Hour(checkblockapp[i].time);
            this.opdvisitService.blockTimeSingleValue.EntryDateTime =
              this.convertTo24Hour(checkblockapp[i].time);
            this.opdvisitService.blockTimeSingleValue.fk_ScheduleTypeId =
              checkblockapp[i].scheduleTypeId;
            this.opdvisitService.blockTimeSingleValue.reason = null;
            this.opdvisitService.blockTimeValues.push(
              this.opdvisitService.blockTimeSingleValue
            );
          }
          document.getElementById("blockAppoitnmentModel").style.display =
            "block";
        } else {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg10"],
            this.authService.appointmentMsg["Ok"]
          );
        }
      }
    }
  }
  ReleaseAll() {

    if (this.opdvisitService.blockTimeValues.length > 0) {
      let now = this.authService.localDate;
      var xHr = now.getHours();
      var xMin = now.getMinutes();
      var yTime = this.convertTo24Hour(this.slottime);

      if (
        Date.parse(
          this.datePipe.transform(this.today, "yyyy-MM-dd").toString()
        ) ==
        Date.parse(
          this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
        )
      ) {
        let ApptX = yTime.split(":");
        this.RealTime = xHr * 60 + xMin;
        this.ApptTime = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);

        if (this.ApptTime < this.RealTime) {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg11"],
            this.authService.appointmentMsg["Ok"]
          );
          return;
        }
      }

      if (
        Date.parse(this.datePipe.transform(this.today, "yyyy-MM-dd").toString()) >
        Date.parse(
          this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
        )
      ) {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg11"],
          this.authService.appointmentMsg["Ok"]
        );
        return;
      }

      if (this.selectisBlock == false) {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg12"],
          this.authService.appointmentMsg["Ok"]
        );
        return;
      }

      if (this.opdvisitService.timeSingleValue.isCancelAppointment != true) {
        //  this.releaseMeAll();
        document.getElementById("releaseAppoitnmentModel").style.display =
          "block";
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg13"],
          this.authService.appointmentMsg["Ok"]
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg12"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }
  cancelMeAll() {
    //    alert("Ruko");

    // console.log(this.blockTimeValues);
    this.dashboardService.subscriptions = this.opdvisitService.cancelAllAppt().pipe(takeUntil(this.destroy$)).subscribe(
      (data) => this.success_cancellAll_save(data),
      (err) => this.failed_cancellAll_save(err)
    );
  }

  success_cancellAll_save(data) {
    this.checkmultiplecancel = false;
    this.selectCancelled = null;
    this.cancelAppointmentReason();
    if (data.length > 0) {
      // if (this.opdvisitService.timevalues.length > 0) {
      //   for (var i = 0; i < this.opdvisitService.timevalues.length; i++) {
      //     if (
      //       this.opdvisitService.timevalues[i].mobileNumber != "" &&
      //       this.opdvisitService.timevalues[i].mobileNumber != null &&
      //       this.opdvisitService.timevalues[i].mobileNumber != undefined
      //     ) {
      //       this.opdvisitService.datasendsms.PatientName =
      //         this.opdvisitService.timevalues[i].patientName;
      //       this.opdvisitService.datasendsms.MobileNo =
      //         this.opdvisitService.timevalues[i].mobileNumber;
      //       this.opdvisitService.datasendsms.MrdNo =
      //         this.opdvisitService.timevalues[i].userId;
      //       this.opdvisitService.datasendsms.SeqNo = null;
      //       this.opdvisitService.datasendsms.ApptDate = null;
      //       this.opdvisitService.datasendsms.ApptTime = null;
      //       this.opdvisitService.datasendsms.ApptConsultant = null;
      //       this.opdvisitService.datasendsms.SurgeryDate = null;
      //       this.opdvisitService.datasendsms.SurgeryTime = null;
      //       this.opdvisitService.datasendsms.BranchId = this.getBranceId;
      //       this.opdvisitService.datasendsms.SMSType = "APPTCANCELLED";
      //       this.opdvisitService.sendSMstoPatient(
      //         this.opdvisitService.datasendsms
      //       );
      //     }
      //   }
      // }
      this.opdvisitService.timevalues = [];
      this.opdvisitService.timeSingleValue = {};
    }
    if (data.length == 1) {
      this.opdvisitService.timevalues = [];
      this.opdvisitService.timeSingleValue = {};
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg14"],
        this.authService.appointmentMsg["Ok"]
      );

    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg15"],
        this.authService.appointmentMsg["Ok"]
      );
    }
    // this.blockTimeDetail.pkTranId = data;

    this.opdvisitService.timevalues = [];
    this.showRec();
  }
  failed_cancellAll_save(err) {
    //alert("Failed");
  }
  CancellAll() {

    if (!this.checkmultiplecancel) {
      // this.dashboardService.openSnackBar(this.authService.appointmentMsg['upgradeMsg.msg16'], this.authService.appointmentMsg['Ok']);
      // return
      if (this.authService.masterdata.allowCancelAllAppt == true) {
        this.opdvisitService.timevalues = this.appservice.docotrSlot.filter(
          (item) =>
            item.appId > 0 && item.isCancelled == false && item.isConfirm != true
        );
        if (this.opdvisitService.timevalues.length > 0) {
          document.getElementById("cancelAppoitnmentModel").style.display = "block";
        } else {
          this.dashboardService.openSnackBar(
            "Not Found Any Booked Appointment",
            "ok"
          );
        }
      } else {
        this.dashboardService.openSnackBar(
          "You don't have permission to cancel all appointments.",
          "ok"
        );
      }
    } else {
      if (this.selectCancelled == null) {
        this.dashboardService.openSnackBar("Please Select Only Booked Appointment", this.authService.appointmentMsg['Ok']);
        return
      }
    }
    if (this.selectCancelled == true) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg17"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }

    let now = this.authService.localDate;
    var xHr = now.getHours();
    var xMin = now.getMinutes();
    var yTime = this.convertTo24Hour(
      this.opdvisitService.blockTimeSingleValue.apptTime
    );
    // if (Date.parse(this.datePipe.transform(this.today, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString())) {
    //   let ApptX = yTime.split(":");
    //   this.RealTime = (xHr * 60) + xMin;
    //   this.ApptTime = (parseInt(ApptX[0]) * 60) + parseInt(ApptX[1]);
    //   if (this.ApptTime < this.RealTime) {
    //     this.dashboardService.openSnackBar("Back Time Not Allowed!", "OK");
    //      return;
    //   }
    // }
    if (
      Date.parse(this.datePipe.transform(this.today, "yyyy-MM-dd").toString()) >
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg18"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }

    if (this.opdvisitService.timevalues.length > 0) {
      if (this.eventcheck != true) {
        // this.cancelMeAll();
        document.getElementById("cancelAppoitnmentModel").style.display =
          "block";
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg19"],
          this.authService.appointmentMsg["Ok"]
        );
      }
    }
  }
  ReActivateMeAll() {
    if (this.opdvisitService.timevalues.length > 0) {
      document.getElementById("ReActivateAppoitnmentModel").style.display = "block";
      var payloadArray = [];
      this.opdvisitService.timevalues.forEach(x => {
        let newpayload = {

          "appId": x.appId,
          "IsCancelled": false,
          "userId": this.authService.Loggeduser.userid,
          "cancelRemarks": ""
        }
        payloadArray.push(newpayload);
      });
      this.dashboardService.subscriptions = this.appservice.ReActiveCancelAppointment(payloadArray).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.CancelReativeAppointment();

        this.opdvisitService.timevalues = [];
        this.opdvisitService.timeSingleValue = {};
        this.selectCancelled = null;
        this.checkmultiplecancel = false;
        this.showRec();
        this.dashboardService.openSnackBar(
          "ReActivate Cancel Appointment Successfully",
          "ok"
        );
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar(
        "Not Found Any Cancel Appointment",
        "ok"
      );
    }
  }
  CancelReativeAppointment() {
    document.getElementById("ReActivateAppoitnmentModel").style.display = "none";
  }
  CancelReActive() {
    if (this.selectCancelled && this.opdvisitService.timevalues.length > 0) {
      this.opdvisitService.timevalues = this.opdvisitService.timevalues.filter(
        (item) => item.isCancelAppointment == true
      );
      if (this.opdvisitService.timevalues.length > 0) {
        document.getElementById("ReActivateAppoitnmentModel").style.display = "block";
      } else {
        this.dashboardService.openSnackBar(
          "Not Found Any Cancel Appointment",
          "ok"
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Cancel Appointment",
        this.authService.appointmentMsg["Ok"]
      );
    }
  }
  addCancelReason() {

    if (this.checkmultiplecancel == false && this.opdvisitService.timevalues.length == 0) {
      this.opdvisitService.timevalues = this.appservice.docotrSlot.filter(
        (item) =>
          item.appId > 0 && item.isCancelled == false && item.isConfirm != true
      );
      if (this.opdvisitService.timevalues.length > 0) {

        this.cancelMeAll();

      } else {
        this.dashboardService.openSnackBar(
          "Not Found Any Booked Appointment",
          "ok"
        );
      }
    } else {

      this.cancelMeAll();


    }
  }
  cancelAppointmentReason() {
    document.getElementById("cancelAppoitnmentModel").style.display = "none";
    this.opdvisitService.timeSingleValue.cancelRemarks = null;
    this.selectCancelled = null;
  }
  blockAppointmentReason() {
    this.opdvisitService.blockTimeValues = [];
    document.getElementById("blockAppoitnmentModel").style.display = "none";
    this.opdvisitService.blockTimeSingleValue.reason == null;
  }
  releaseAppointmentReason() {
    document.getElementById("releaseAppoitnmentModel").style.display = "none";
    this.opdvisitService.blockTimeSingleValue.reason == null;
  }
  opdtrackingData: any = [];
  opdApptTracking() {
    if (this.opdvisitService.timeSingleValue.appId > 0) {
      this.dashboardService.subscriptions = this.appservice
        .getappoitmentTrackin(this.opdvisitService.timeSingleValue.appId).pipe(takeUntil(this.destroy$))
        .subscribe(
          (item: any) => {
            this.opdtrackingData = [];
            if (item.length > 0) {
              this.opdtrackingData = item;
              document.getElementById("opdApptTrackingModal").style.display =
                "block";
            } else {
              this.dashboardService.openSnackBar("No Data Found", "ok");
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Booked Appointment",
        "ok"
      );
    }
  }
  cancelOpdApptTracking() {

    document.getElementById("opdApptTrackingModal").style.display = "none";
  }

  CancelMe(event) {
    if (this.opdvisitService.appId > 0) {
      this.opdvisitService.cancelAppt();
    }
  }

  ReleaseMe() {
    if (this.blockTime.length > 0) {
      this.opdvisitService.releaseBlockAppt();
      this.blockTime = "";
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg12"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }
  BlockMe() {
    if (this.blockTime.length > 0) {
      // this.open_loader_Dialog();
      this.opdvisitService.showspinner = true;
      this.opdvisitService.saveBlockAppt();
      this.blockTime = "";
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg20"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }

  getBlockTime(time, appId) {
    this.appId = appId;
    this.blockTime = time;
    this.opdvisitService.appId = appId;
    this.opdvisitService.blockApptTime = time;
  }

  getBlockTimeAll(event, time, appId, scheduleid) {
    this.opdvisitService.blockTimeSingleValue = {};
    this.opdvisitService.blockTimeSingleValue.apptTime = time;
    this.opdvisitService.blockTimeSingleValue.fkBranchId = this.getBranceId;
    this.opdvisitService.blockTimeSingleValue.fkCreatedById =
      this.authService.Loggeduser.userid;
    this.opdvisitService.blockTimeSingleValue.isActive = "true";
    this.opdvisitService.blockTimeSingleValue.pkTranId = 0;
    this.opdvisitService.blockTimeSingleValue.fkDoctorId = parseInt(
      this.appservice.DoctorId
    );
    this.opdvisitService.blockTimeSingleValue.apptDate =
      this.appservice.selectedDate;
    this.opdvisitService.blockTimeSingleValue.apptTime =
      this.convertTo24Hour(time);
    this.opdvisitService.blockTimeSingleValue.EntryDateTime =
      this.convertTo24Hour(time);
    this.opdvisitService.blockTimeSingleValue.fk_ScheduleTypeId = scheduleid;
    this.opdvisitService.blockTimeSingleValue.reason = null;
    //this.blockApptTime.substring(0,this.blockApptTime.length-2)
    if (event.checked == true) {
      if (this.rescheduleapp == true) {
        this.opdvisitService.blockTimeValues = [];
        this.opdvisitService.blockTimeValues.push(
          this.opdvisitService.blockTimeSingleValue
        );
        this.rescheduleonGrid(this.rowdata);
        return;
      }
      this.opdvisitService.blockTimeValues.push(
        this.opdvisitService.blockTimeSingleValue
      );
    } else {
      this.opdvisitService.blockTimeValues =
        this.opdvisitService.blockTimeValues.filter(
          (item) =>
            item.apptTime !== this.opdvisitService.blockTimeSingleValue.apptTime
        );
    }
  }
  slottime: any;
  checkmultiplecancel: boolean = false;
  getvalues(
    event,
    ids,
    time,
    confirm,
    cappointment,
    pname,
    mnumber,
    rowdata: any,
    scheduleid: number
  ) {
    // this.checkmultiplecancel = event.checked;
    this.rescheduleapp = false;
    this.selectisBlock = rowdata.isBlock;
    this.selectCancelled = rowdata.isCancelled;
    this.getBlockTimeAll(event, time, ids, scheduleid);
    this.opdvisitService.timeSingleValue = {};
    this.slottime = time;
    this.eventcheck = confirm;

    if (ids == null) {
      this.opdvisitService.timeSingleValue.appId = 0;
      this.opdvisitService.timeSingleValue.patientName = null;
      this.opdvisitService.timeSingleValue.mobileNumber = null;
      this.opdvisitService.timeSingleValue.isConfirm = null;
      this.opdvisitService.timeSingleValue.isCancelAppointment = null;
    } else {
      this.opdvisitService.timeSingleValue.appId = ids;
      this.opdvisitService.timeSingleValue.patientName = pname;
      this.opdvisitService.timeSingleValue.mobileNumber = mnumber;
      this.opdvisitService.timeSingleValue.isConfirm = confirm;
      this.opdvisitService.timeSingleValue.isCancelAppointment = cappointment;
    }
    this.opdvisitService.timeSingleValue.userId =
      this.authService.Loggeduser.userid;

    if (event.checked == true) {
      // alert("after check");
      this.opdvisitService.timevalues.push(
        this.opdvisitService.timeSingleValue
      );
      this.checkmultiplecancel = true;
      //  console.log(this.opdvisitService.timevalues);
      //  console.log("chkbox checked");
    } else {
      this.opdvisitService.timevalues = this.opdvisitService.timevalues.filter(
        (item) => item.appId !== this.opdvisitService.timeSingleValue.appId
      );
      if (this.opdvisitService.timevalues.length == 0) {
        this.selectCancelled = null;
        this.checkmultiplecancel = false;
        this.opdvisitService.timeSingleValue = {};
      }
    }
  }

  onSelectAppListOnline(event) {

    this.appservice.selectedDateListOnline = this.datePipe.transform(
      event.value,
      "yyyy-MM-dd"
    );

  }

  //om
  _gethospital_total_appointments() {
    this.dashboardService.subscriptions = this.dashboardService.gethospitalToalAppt().pipe(takeUntil(this.destroy$)).subscribe(
      (data) => this.success_hospital_total_appointments(data),
      (err) => this.failed_hospital_total_appointments(err)
    );
  }
  success_hospital_total_appointments(data) {
    this.total_appointment_count = data;
  }

  failed_hospital_total_appointments(err) {
    this.total_appointment_count = 0;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  sortData(sort: Sort) {
    const data = this.GetAppListDataOnline.slice();
    if (!sort.active || sort.direction === '') {
      this.GetAppListDataOnline = data;
      return;
    }

    this.GetAppListDataOnline = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'BookingDate':
          return this.compare(a.bookingDate, b.bookingDate, isAsc);
        case 'ApptDate':
          return this.compare(a.appDate, b.appDate, isAsc);
        case 'ApptTime':
          return this.compare(a.appTime, b.appTime, isAsc);
        case 'Doctor_name':
          return this.compare(a.doctorName, b.doctorName, isAsc);
        case 'patient_id':
          return this.compare(a.patientId, b.patientId, isAsc);
        case 'patient_name':
          return this.compare(a.patientName, b.patientName, isAsc);
        case 'contact_no':
          return this.compare(a.contactNo, b.contactNo, isAsc);
        case 'referredry':
          return this.compare(a.referredBy, b.referredBy, isAsc);
        case 'appt_type':
          return this.compare(a.appType, b.appType, isAsc);
        case 'appt_take_by':
          return this.compare(a.appTakenBy, b.appTakenBy, isAsc);
        case 'given_by':
          return this.compare(a.givenBy, b.givenBy, isAsc);
        case 'modify_by':
          return this.compare(a.modifyBy, b.modifyBy, isAsc);

        default:
          return 0;
      }
    });
  }
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  open_loader_Dialog(): void {
    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: "300px",
      data: {},
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  // selectMe(dessert1) {

  //   this.appservice.Doctor_time_info_Mod=[];
  //   this.selecteddoctor = dessert1.userName;
  //   this.open_loader_Dialog();

  //   this.dashboardService.selectedRowIndex = dessert1.userId;

  //   this.opdvisitService.apptdetail.fkConsultantId = dessert1.userId
  //   this.appservice.DoctorId = dessert1.userId;
  //   this.opdvisitService.DoctorId = dessert1.userId;

  //   if (parseInt(this.appservice.selectedDate) > 0) {
  //     if (parseInt(this.appservice.DoctorId) > 0) {

  //       this.appservice.Doctor_time_info_Method().subscribe(data => this.successlist(data)
  //         , err => this.errlist(err));

  //     }
  //     else {
  //       alert("Please Select Date!");
  //     }

  //   }
  //   else {
  //     alert("Please Select Doctor!");
  //   }
  // }
  errlist(err) {
    //  this.dialog.closeAll();
    this.opdvisitService.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  selectMeALL(dessert1?: any) {

    this.opdvisitService.timevalues = [];
    this.selecteddoctor = dessert1.userName;
    // this.open_loader_Dialog();
    this.opdvisitService.showspinner = true;
    this.dashboardService.selectedRowIndex = dessert1.userId;
    this.opdvisitService.apptdetail.fkConsultantId = dessert1.userId;
    this.appservice.DoctorId = dessert1.userId;
    this.opdvisitService.DoctorId = dessert1.userId;
    if (parseInt(this.appservice.selectedDate) > 0) {
      if (parseInt(this.appservice.DoctorId) > 0) {
        //this.appservice.getData();
        this.dashboardService.subscriptions = this.appservice.Doctor_time_info_Method(this.getBranceId).pipe(takeUntil(this.destroy$)).subscribe(
          (data) => this.successlist(data),
          (err) => this.errlist(err)
        );
      } else {
        alert(this.authService.appointmentMsg["upgradeMsg.msg1"]);
      }
    } else {
      alert(this.authService.appointmentMsg["upgradeMsg.msg2"]);
    }
  }

  setStep(index: number) {
    this.current_schedule = index;
  }

  onOptionsSelectedAllView(value) {

    if (value == 0) {
      this.appservice.fullviewArray = this.appservice.docotrSlot;
      this.groupArr = this.appservice.docotrSlot.reduce(
        (r, { scheduleType }) => {
          if (!r.some((o) => o.scheduleType == scheduleType)) {
            r.push({
              scheduleType,
              groupItem: this.appservice.docotrSlot.filter(
                (v) => v.scheduleType == scheduleType
              ),
            });
          }
          return r;
        },
        []
      );
      this.appservice.Doctor_time_info_Mod = this.groupArr;
    } else if (value == 1) {
      const checkschedule = this.appservice.docotrSlot.filter(
        (item) => item.isCancelled != true && item.isBlock != true
      );
      this.appservice.fullviewArray = checkschedule;
      this.groupArr = checkschedule.reduce((r, { scheduleType }) => {
        if (!r.some((o) => o.scheduleType == scheduleType)) {
          r.push({
            scheduleType,
            groupItem: checkschedule.filter(
              (v) => v.scheduleType == scheduleType
            ),
          });
        }
        return r;
      }, []);
      this.appservice.Doctor_time_info_Mod = this.groupArr;
    }
  }
  groupArr: any;

  successlist(data) {

    this.appservice.Doctor_time_info_Mod = [];
    this.appservice.fullviewArray = [];
    this.appservice.docotrSlot = [];
    this.appservice.fullviewArray = data;
    this.appservice.docotrSlot = data;
    this.groupArr = data.reduce((r, { scheduleType }) => {
      if (!r.some((o) => o.scheduleType == scheduleType)) {
        r.push({
          scheduleType,
          groupItem: data.filter((v) => v.scheduleType == scheduleType),
        });
      }
      return r;
    }, []);
    this.appservice.Doctor_time_info_Mod = this.groupArr;

    this.ReportedApp = 0;
    this.CancelledApp = 0;
    this.isBlockApp = 0;
    this.isConfirmApp = 0;
    this.TotalApp = 0;
    for (var var1 of this.appservice.Doctor_time_info_Mod) {
      for (var val of var1.groupItem) {
        if (val.patientName != null) {
          this.TotalApp = this.TotalApp + 1;
        }
        if (val.isConfirm == true) {
          this.ReportedApp = this.ReportedApp + 1;
          // alert(val.time+" In Confirm "+val.isConfirm);
        } else if (val.isCancelled == true) {
          this.CancelledApp = this.CancelledApp + 1;
        } else if (val.isBlock == true) {
          this.isBlockApp = this.isBlockApp + 1;
        } else if (val.isConfirm == false) {
          this.isConfirmApp = this.isConfirmApp + 1;
        }
      }
    }
    if (data.length > 0) {
      if (data[0].slotLimit != undefined) {
        this.apptSlotLimit = data[0].slotLimit;
      }
    }
    //this.appservice.setschedules();
    // this.dialog.closeAll();
    this.opdvisitService.showspinner = false;
    if (this.reschedule == true) {
      this.closeGrid();
    }
  }
  // setdefault_time() {
  //   var st = this.srvTime();
  //   const tdate = new Date(st);

  //   let time = tdate.toLocaleTimeString().split(" ", 2);
  //   let time_hours_minutes = time[0].split(":", 3);

  //   if (
  //     time[1] == "AM" &&
  //     parseInt(time_hours_minutes[0]) > 0 &&
  //     parseInt(time_hours_minutes[0]) <= 12
  //   ) {
  //     this.current_schedule = 1;
  //   } else if (
  //     (time[1] == "PM" &&
  //       parseInt(time_hours_minutes[0]) > 0 &&
  //       parseInt(time_hours_minutes[0]) < 3) ||
  //     parseInt(time_hours_minutes[0]) == 12
  //   ) {
  //     this.current_schedule = 2;
  //   } else if (
  //     time[1] == "PM" &&
  //     parseInt(time_hours_minutes[0]) >= 3 &&
  //     parseInt(time_hours_minutes[0]) < 5
  //   ) {
  //     this.current_schedule = 3;
  //     console.log("name changed " + this.current_schedule);
  //   } else if (
  //     time[1] == "PM" &&
  //     parseInt(time_hours_minutes[0]) >= 5 &&
  //     parseInt(time_hours_minutes[0]) <= 11
  //   ) {
  //     this.current_schedule = 4;
  //   }
  // }
  // setschedules() {
  //   this.get_morning_schedule();
  //   this.get_noon_schedule();
  //   this.get_evening_schedule();
  //   this.get_night_schedule();
  // }

  // get_morning_schedule() {
  //   this.morning_schedule = this.appservice.Doctor_time_info_Mod.filter(
  //     (item) =>
  //       item.time.indexOf("AM") > -1 &&
  //       parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) > 0 &&
  //       parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <= 12
  //   );
  // }
  // get_noon_schedule() {
  //   this.afternoon_schedule = this.appservice.Doctor_time_info_Mod.filter(
  //     (item) =>
  //       (item.time.indexOf("PM") > -1 &&
  //         parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) == 12) ||
  //       (parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) > 0 &&
  //         parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <= 3)
  //   );
  // }
  // get_evening_schedule() {
  //   this.evening_schedule = this.appservice.Doctor_time_info_Mod.filter(
  //     (item) =>
  //       item.time.indexOf("PM") > -1 &&
  //       parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) > 3 &&
  //       parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <= 5
  //   );
  // }
  // get_night_schedule() {
  //   this.night_schedule = this.appservice.Doctor_time_info_Mod.filter(
  //     (item) =>
  //       item.time.indexOf("PM") > -1 &&
  //       parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) > 5 &&
  //       parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <= 11
  //   );
  // }
  holidatcheck() {
    this.dashboardService.subscriptions = this.appservice.Doctor_time_info_Method(this.getBranceId).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => this.successlistholiday(data),
      (err) => this.errlist(err)
    );
  }
  successlistholiday(data) {
    this.appservice.docotrSlot = data;
  }
  showRec() {
    // this.open_loader_Dialog();
    this.opdvisitService.showspinner = true;
    if (parseInt(this.appservice.selectedDate) > 0) {
      if (parseInt(this.appservice.DoctorId) > 0) {
        // this.appservice.getData();
        this.dashboardService.subscriptions = this.appservice.Doctor_time_info_Method(this.getBranceId).pipe(takeUntil(this.destroy$)).subscribe(
          (data) => this.successlist(data),
          (err) => this.errlist(err)
        );
      } else {
        alert(this.authService.appointmentMsg["upgradeMsg.msg1"]);
        this.opdvisitService.showspinner = false;
      }
    }
  }
  drname: any;
  GetDrId(event) {
    this.appservice.FK_DoctorId = event.id;
    this.drname = event.value;
  }
  selectAllDoct(event) {
    let value = event.target.value;
    if (value == "") {
      this.appservice.FK_DoctorId = 0;
    }
  }
  GetbranchId(event) {
    this.apptbranchid = event.option.id;
  }

  GetApptStatus(event) {
    if (event.length > 0) {
      this.ApptStatus = event;
      this.appservice.ApptStatus = event;
    } else {
      this.ApptStatus = "";
    }
  }
  get_success(data) {
    if (this.appservice.allPatientCons == true) {
    }
    this.ConsListData = data;
    // this.dialog.closeAll();
    this.opdvisitService.showspinner = false;
  }
  get_fail(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  GetReportCons() {
 const surgeryStatus = this.appservice.Surgery?.trim();
  if (!surgeryStatus || surgeryStatus.length < 3) {
    this.appservice.Surgeryid = null;
    this.dashboardService.openSnackBar("Please select the Surgery Status", "Ok");
    return;
  }
    if (this.appservice.allPatientCons == true) {
      this.appservice.Reported = "";
      this.appservice.Cancelled = "";
      // this.open_loader_Dialog();
      this.opdvisitService.showspinner = true;
      this.dashboardService.subscriptions = this.appservice.ConsListData(
        this.appservice.selectfromdatelist,
        this.authService.Loggeduser.branchid,
        this.appservice.FK_DoctorId,
        this.appservice.PatientId, 
        this.appservice.Surgeryid,
        this.appservice.selectedDateList).pipe(takeUntil(this.destroy$)).subscribe(
        (data) => this.get_success(data),
        (err) => this.get_fail(err));
    } else {
      {
      }
      this.dashboardService.subscriptions = this.appservice
        .ConsListData(
        this.appservice.selectfromdatelist,
        this.authService.Loggeduser.branchid,
        this.appservice.FK_DoctorId,
        this.appservice.PatientId, 
        this.appservice.Surgeryid,
        this.appservice.selectedDateList
        ).pipe(takeUntil(this.destroy$))
        .subscribe((data) => (this.ConsListData = data));
    }
  }

 clene(type: string) {
  if (type === 'UHID') {
    if (!this.appservice.PatientId || this.appservice.PatientId.toString().trim() === '') {
      this.appservice.PatientId = 0;
    }
  } else if(type == 'status') {
    this.appservice.Surgeryid = null;
    this.appservice.Surgery = null;

  }
}


  get_app_success(data) {
    // this.dialog.closeAll();
    this.GetAppListData = data;
    this.getAppListCount = data.length;
  }
  get_app_fail(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  exportexcel(): void {
    let element = document.getElementById("content");
    this.exportdata.exportxcel(element);
  }

  GetReport() {
    if (this.appservice.allPatient == true) {
      //this.open_loader_Dialog();
      this.appservice.Reported = "status";
      this.appservice.Cancelled = "status";
      this.dashboardService.subscriptions = this.appservice.GetAppListData().pipe(takeUntil(this.destroy$)).subscribe(
        (data) => this.get_app_success(data),
        (err) => this.get_app_fail(err)
      );
      //          this.appservice.GetAppListData().subscribe(data=>this.GetAppListData= data);

      //          this.appservice.ConsListData().subscribe(data=>this.get_success(data), err =>this.get_fail(err));
    } else {
      if (this.drId > 0 && this.appservice.selectedDateList.length > 0) {
        // this.open_loader_Dialog();
        this.opdvisitService.showspinner = true;
        //alert("Reported:"+this.ReportingStatus+"Cancelled:"+this.CancelStatus);
        this.appservice.Reported = this.ReportingStatus;
        this.appservice.Cancelled = this.CancelStatus;
        this.dashboardService.subscriptions = this.appservice
          .GetAppListData().pipe(takeUntil(this.destroy$))
          .subscribe((data) => (this.GetAppListData = data));
      } else {
        alert(this.authService.appointmentMsg["upgradeMsg.msg21"]);
      }
    }
  }

  allPatient(event) {
    this.AllPatient = event.checked;
    this.appservice.allPatient = event.checked;
  }
  allPatientCons(event) {
    this.AllPatientCons = event.checked;
    this.appservice.allPatientCons = event.checked;
  }

  GetCancelStatus(event) {
    this.CancelStatus = event.option.id;
    this.appservice.Cancelled = event.option.id;
  }

  GetSurgeryStatus(event) {
    this.appservice.Surgery = event.value;
    this.appservice.Surgeryid = event.id;

  }
  GetReportingStatus(event) {
    this.ReportingStatus = event.option.id;
    this.appservice.Reported = event.option.id;
  }
  GettemplateStatus(event) {
    this.seletedTemp = event.option.value;
  }

  get_on_fail(err) {
    this.opdvisitService.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  GetReportOnline() {
    if (this.ApptStatus.length > 0) {
      // this.open_loader_Dialog();
      this.opdvisitService.showspinner = true;
      this.dashboardService.subscriptions = this.appservice.GetAppListDataOnline().pipe(takeUntil(this.destroy$)).subscribe(
        (data) => this.get_on_success(data),
        (err) => this.get_on_fail(err)
      );

      //this.appservice.GetAppListDataOnline().subscribe(data=>this.GetAppListDataOnline= data)

      //this.appservice.ConsListData().subscribe(data=>this.get_success(data), err =>this.get_fail(err));
    } else {
      this.dashboardService.openSnackBar(this.authService.appointmentMsg["upgradeMsg.msg22"], "OK");

    }
  }
  GetOnline() { }
  getcolor(data, data1, IsCancel, ConfirmMe) {
    // console.log(data+"Haw-"+ConfirmMe);
    if (
      data != null ||
      data1 != null ||
      IsCancel != null ||
      ConfirmMe != null
    ) {
      // if (data.length > 0) {
      //  this.TotalApp=this.TotalApp+1;
      // alert("In app data"+data+" Cancel"+IsCancel);
      if (IsCancel == true) {
        return this.appointmentColorobj.cancelledAppointment;
      } else {
        if (ConfirmMe == true) {
          return this.appointmentColorobj.reportedAppointment;
        } else if (data1 == true) {
          return this.appointmentColorobj.blockedAppointment;
        } else if (data != null) {
          return "#b7c3d9";
        } else if (data == null && data1 == false) {
          return this.appointmentColorobj.bookedAppointment;
        }
      }
    } else {
      return this.appointmentColorobj.bookedAppointment;
    }
    // }else{
    //   return "#ebebeb";
    // }
  }

  getcolorBlock(data) {
    if (data != null && data != undefined)
      if (data.length > 0) {
        return "#998b8b";
      } else {
        return "#ebebeb";
      }
  }


  get_on_success(data) {
    this.GetAppListDataOnline = data;
    // this.dialog.closeAll();
    this.opdvisitService.showspinner = false;
  }
  intervalId: any;
  selectmultipleAppDate: any;
  selectminAppDate: any;
  fistSection: boolean = true;
  secondSection: boolean = true;
  thirdSection: boolean = true;
  fourthSection: boolean = true;
  ngOnInit() {
    this.get_patients_fields_config();
    // this.initializeConsBranchControl();
    this.opdvisitService.callsepecificApi = "ALL";
    this.branchName = this.authService.Branches;
    // this.appservice.testappointment_services();
    this.appservice.DoctorId;
    this.appservice.Doctor_time_info_Mod = [];

    this.appservice.selectedDateList = this.datePipe.transform(
      this.authService.getServerDate,
      "yyyy-MM-dd"
    );

   this.appservice.selectfromdatelist = this.datePipe.transform(this.authService.getServerDate,"yyyy-MM-dd");

    this.selectmultipleAppDate = this.datePipe.transform(
      this.authService.getServerDate,
      "yyyy-MM-dd"
    );
    this.selectminAppDate = this.datePipe.transform(
      this.authService.getServerDate,
      "yyyy-MM-dd"
    );
    this.appservice.selectedDateListOnline = this.datePipe.transform(
      this.authService.getServerDate,
      "yyyy-MM-dd"
    );
    let changedate = new Date(this.authService.getServerDate);
    this.fromDateDrSummery = this.datePipe.transform(changedate.setDate(changedate.getDate() + 1), 'yyyy-MM-dd');
    this.toDateDrSummery = this.datePipe.transform(changedate.setDate(changedate.getDate() + 14), 'yyyy-MM-dd');
    // this.getDoctorBrach();
    //this.showRec();
    //this.appservice.setdefault_time();
    // this.setdefault_time();
    this.getAppoitmentType();
    this.reschedule = false;
    this.branchList();
    this.getreporting();
    this.getcancel();
    this.apptbranchid = this.getBranceId;
    this.getTemplate(this.apptbranchid);
    this.ReportingStatus = 1;
    this.CancelStatus = 1;
    this.getTakenon();
    this.referedbyControll();
    if (this.authService.Branches.length >= 4) {
      this.fistSection = true;
      this.secondSection = true;
      this.thirdSection = true;
      this.fourthSection = true;
    } else if (this.authService.Branches.length == 3) {
      this.fistSection = true;
      this.secondSection = true;
      this.thirdSection = true;
      this.fourthSection = false;
    } else if (this.authService.Branches.length == 2) {
      this.fistSection = true;
      this.secondSection = true;
      this.thirdSection = false;
      this.fourthSection = false;
    } else if (this.authService.Branches.length == 1) {
      this.fistSection = true;
      this.secondSection = false;
      this.thirdSection = false;
      this.fourthSection = false;
    }
    this.appservice.Surgery = 'Pending';

  const pendingItem = this.statusArray.find(x => x.surgeryStatus == 'Pending');
  if (pendingItem) {
    this.appservice.Surgeryid = pendingItem.pK_SurgeryStatusId;
    this.consControl.setValue('Pending');
  }
  }

  get_patients_fields_config() {

    this.dashboardService.subscriptions = this.opdvisitService.getPatientConfig().pipe(takeUntil(this.destroy$)).subscribe(
      data => this.success_config(data),
      err => this.error_config(err)
    );
  }
  patient_mendatory_fields: PatientFieldsModel[] = [];
  success_config(data) {

    this.patient_mendatory_fields = [];
    this.patient_mendatory_fields = data;
    if (this.patient_mendatory_fields.length == 0) {
      this.opdvisitService.apptdetail.fkCityId = null;
      this.dashboardService.openSnackBar("Please Update The Configuration The Patient in Masters ", "OK");
    } else {
      if (this.patient_mendatory_fields[0]?.mandatoryInitial != true) {
        this.checkgender = false;
      }

      this.opdvisitService.apptdetail.fkCityId = this.patient_mendatory_fields[0]?.fK_CityId ? this.patient_mendatory_fields[0]?.fK_CityId : null;
    }
  }
  error_config(err) {
    this.opdvisitService.apptdetail.fkCityId = null;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  referedbyControll() {
    this.inputControl = new FormControl();
    this.filteredItems = this.inputControl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filter(cat) : this.opdvisitService.personmaster.slice()
      )
    );
  }
  newPersonArray: any = [];
  filter(value: any) {
    if (value && typeof value != "number") {
      const filterValue = value.toLowerCase();
      const returndata = this.opdvisitService.personmaster.filter(
        (country) =>
          country.personName?.toLowerCase().indexOf(filterValue) === 0
      );
      if (returndata.length == 0 && value.length >= 3) {
        this.dashboardService.subscriptions = this.opdvisitService
          .getpersonMasterSpecific("APPOINTMENT", value).pipe(takeUntil(this.destroy$))
          .subscribe((x: any) => {
            this.newPersonArray = [];
            this.newPersonArray = x;
            this.filteredItems = this.inputControl.valueChanges.pipe(
              startWith(""),
              map((cat) => this.newPersonArray.slice())
            );
          });
      } else {
        return returndata;
      }
    }
  }
  CheckinputRef(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.opdvisitService.apptdetail.fkRefById = 0;
      // this.validatereferredby = true;
      this.filterreferd = null;
      this.referedbyControll();
    } else {
      this.filterreferd = checkdata;
    }
  }
  getreferedbyobj(e: any) {
    var val = e.option.value;
    this.filterreferd = val.personName;
    this.opdvisitService.apptdetail.fkRefById = val.pkPersonId;
  }

  apptList: any = [];
  checkemergency: any = [];
  getAppoitmentType() {
    this.dashboardService.subscriptions = this.appservice.getappoitmentType().pipe(takeUntil(this.destroy$)).subscribe(
      (x: any) => {
        this.apptList = [];
        this.checkemergency = [];
        this.apptList = x;
        if (this.apptList.length > 0) {
          this.checkemergency = this.apptList.filter(
            (item) => item.apptType.toLowerCase() == "emergency"
          );
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  //get schedule type
  getDoctorBrach(branchid, type) {
    this.appservice.app_doctors(this.doctortype, branchid, this.appservice.selectedDate).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => this.success_doctors(data, type),
      (err) => this.failed_doctors(err)
    );
  }
  doctorList1: any = [];
  doctorList2: any = [];
  doctorList3: any = [];
  doctorList4: any = [];


  success_doctors(data, type) {
    this.doctorList1 = [];
    this.doctorList2 = [];
    this.doctorList3 = [];
    this.doctorList4 = [];
    if (type == 0) {
      if (this.authService.masterdata.isExternal === true) {
        this.appservice.doctors = data.filter(
          (item) => item.isExternal == false
        );
        if (data.length > 0) {
          this.selectMeALL(this.appservice.doctors[0]);
        } else {
          this.appservice.fullviewArray = [];
          this.appservice.Doctor_time_info_Mod = [];
          this.holidatcheck();
        }
      } else {
        this.appservice.doctors = data;
        if (data.length > 0) {
          this.selectMeALL(this.appservice.doctors[0]);
        } else {
          this.appservice.Doctor_time_info_Mod = [];
          this.appservice.fullviewArray = [];
          this.holidatcheck();
        }
      }
      this.doctorControll();
    } else if (type == 1) {
      this.doctorList1 = data;
      this.doctorControll1();
    } else if (type == 2) {
      this.doctorList2 = data;
      this.doctorControll2();
    } else if (type == 3) {
      this.doctorList3 = data;
      this.doctorControll3();
    } else if (type == 4) {
      this.doctorList4 = data;
      this.doctorControll4();
    } else if (type == 5) {
      if (this.authService.masterdata.isExternal === true) {
        this.appservice.doctors = data.filter(
          (item) => item.isExternal == false
        );
        this.doctorList1 = data.filter((item) => item.isExternal == false);
        this.doctorList2 = data.filter((item) => item.isExternal == false);
        this.doctorList3 = data.filter((item) => item.isExternal == false);
        this.doctorList4 = data.filter((item) => item.isExternal == false);
        if (data.length > 0) {
          this.selectMeALL(this.appservice.doctors[0]);
        } else {
          this.appservice.Doctor_time_info_Mod = [];
          this.appservice.fullviewArray = [];

          this.holidatcheck();
        }
      } else {
        this.appservice.doctors = data;
        this.doctorList1 = data;
        this.doctorList2 = data;
        this.doctorList3 = data;
        this.doctorList4 = data;
        if (data.length > 0) {
          this.selectMeALL(this.appservice.doctors[0]);
        } else {
          this.appservice.Doctor_time_info_Mod = [];
          this.appservice.fullviewArray = [];

          this.holidatcheck();
        }
      }
      this.doctorControll();
      this.doctorControll1();
      this.doctorControll2();
      this.doctorControll3();
      this.doctorControll4();
    }
  }
  checkUserName(event, type) {

    if (!event && type == 1) {
      this.DoctorCtrl1.setValue(null)
      this.doctorControll1();
      this.multipleSacheduleArray1 = [];
      this.firstTime = null;
      this.selectedDoctorName = '';
    } else if (!event && type == 2) {
      this.DoctorCtrl2.setValue(null)
      this.doctorControll2();
      this.multipleSacheduleArray2 = [];
      this.secondTime = null;
      this.selectedDoctorName2 = '';
    } else if (!event && type == 3) {
      this.DoctorCtrl3.setValue(null)
      this.doctorControll3();
      this.multipleSacheduleArray3 = [];
      this.thirdTime = null;
      this.selectedDoctorName3 = '';
    } else if (!event && type == 4) {
      this.DoctorCtrl4.setValue(null)
      this.doctorControll4();
      this.multipleSacheduleArray4 = [];
      this.fourthTime = null;
      this.selectedDoctorName4 = '';
    }
  }
  doctorControll1() {
    this.filteredDoctorArray1 = this.DoctorCtrl1.valueChanges.pipe(
      startWith(""),
      map((cat) => this.doctorList1.slice())
    );
  }
  doctorControll2() {
    this.filteredDoctorArray2 = this.DoctorCtrl2.valueChanges.pipe(
      startWith(""),
      map((cat) => this.doctorList2.slice())
    );
  }
  doctorControll3() {
    this.filteredDoctorArray3 = this.DoctorCtrl3.valueChanges.pipe(
      startWith(""),
      map((cat) => this.doctorList3.slice())
    );
  }
  doctorControll4() {
    this.filteredDoctorArray4 = this.DoctorCtrl4.valueChanges.pipe(
      startWith(""),
      map((cat) => this.doctorList4.slice())
    );
  }
  multipleSacheduleArray1: any = [];
  multipleSacheduleArray2: any = [];
  multipleSacheduleArray3: any = [];
  multipleSacheduleArray4: any = [];
  rowlenth1: any;
  GetScheduleListId(event, branchid, type) {
    let localdate = this.datePipe.transform(
      this.selectmultipleAppDate,
      "yyyy-MM-dd"
    );
    this.dashboardService.subscriptions = this.appservice
      .Doctor_time_Schedule_Method(event.option.id, branchid, localdate).pipe(takeUntil(this.destroy$))
      .subscribe(
        (data: any) => {
          var nedataarray = [];
          var unblockdata = [];
          if (data.length > 0) {
            unblockdata = data.filter(item => item.isBlock != true);
            if (
              Date.parse(
                this.datePipe.transform(this.today, "yyyy-MM-dd").toString()
              ) ==
              Date.parse(
                this.datePipe
                  .transform(this.selectmultipleAppDate, "yyyy-MM-dd")
                  .toString()
              )
            ) {
              for (var i = 0; i < unblockdata.length; i++) {
                let now = this.authService.localDate;
                var xHr = now.getHours(); //
                var xMin = now.getMinutes(); //
                var yTime = this.convertTo24Hour(unblockdata[i].time);
                let ApptX = yTime.split(":");
                var RealTime = xHr * 60 + xMin;
                var ApptTime = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);
                if (ApptTime >= RealTime) {
                  nedataarray.push(unblockdata[i]);
                }
              }
            } else {
              nedataarray = unblockdata;
            }
          }
          var newfilterData = [];
          newfilterData = nedataarray.reduce((unique, o) => {
            if (!unique.some(obj => obj.time === o.time)) {
              unique.push(o);
            }
            return unique;
          }, []);
          if (type == 1) {
            this.multipleSacheduleArray1 = newfilterData;
            this.selectedDoctorName = event.option.value;

          } else if (type == 2) {
            this.multipleSacheduleArray2 = newfilterData;
            this.selectedDoctorName2 = event.option.value;

          } else if (type == 3) {
            this.multipleSacheduleArray3 = newfilterData;
            this.selectedDoctorName3 = event.option.value;

          } else if (type == 4) {
            this.multipleSacheduleArray4 = newfilterData;
            this.selectedDoctorName4 = event.option.value;
          }
        },
        (err) => {

          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  schClicked: number = -1;
  schClicked2: number = -1;
  schClicked3: number = -1;
  schClicked4: number = -1;
  firstTime: string = "";
  secondTime: string = "";
  thirdTime: string = "";
  fourthTime: string = "";
  firstslot = [];
  secondslot = [];
  thirdslot = [];
  fourthslot = [];
  checkpushdata: boolean = false;
  selectRowColor(data, index, type, brachid) {

    this.checkpushdata = false;
    if (this.savemultipleArray.length > 0) {
      const checksametime = this.savemultipleArray.filter(
        (item) => item.time == data.time
      );
      if (checksametime.length > 0) {

        this.checkpushdata = true;
        this.dashboardService.openSnackBar(
          "This Time is Already Selected Please Select Another Time",
          "ok"
        );
        return;
      }

      this.savemultipleArray.forEach(item => {
        var xchecktime = this.convertTo24Hour(item.time);
        let ApptcheckX = xchecktime.split(":");
        var xcheck24time = parseInt(ApptcheckX[0]) * 60 + parseInt(ApptcheckX[1]);

        var yTime = this.convertTo24Hour(data.time);
        let ApptX = yTime.split(":");
        var y24time = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);
        const diffchecktime = Number(y24time) - Number(xcheck24time);
        const diffpositivetime = Math.abs(diffchecktime);

        if (30 > diffpositivetime) {
          this.checkpushdata = true;
          this.dashboardService.openSnackBar(
            "Time difference should be 30 Minutes",
            "ok"
          );
          return;
        }
      });
    }
    if (this.checkpushdata == false) {
      switch (type) {
        case 1: {
          this.firstslot = [];
          if (this.schClicked === index) {
            this.schClicked = -1;
            this.firstTime = "";
          } else {
            this.firstTime = data.time;
            this.schClicked = index;
            data["branchid"] = this.getBranceId1;
            this.firstslot.push(data);
          }
          break;
        }
        case 2: {
          this.secondslot = [];
          if (this.schClicked2 === index) {
            this.schClicked2 = -1;
            this.secondTime = "";
          } else {
            this.secondTime = data.time;
            this.schClicked2 = index;
            data["branchid"] = this.getBranceId2;
            this.secondslot.push(data);
          }
          break;
        }
        case 3: {
          this.thirdslot = [];
          if (this.schClicked3 === index) {
            this.schClicked3 = -1;
            this.thirdTime = "";
          } else {
            this.thirdTime = data.time;
            this.schClicked3 = index;
            data["branchid"] = this.getBranceId3;
            this.thirdslot.push(data);
          }
          break;
        }
        case 4: {
          this.fourthslot = [];
          if (this.schClicked4 === index) {
            this.schClicked4 = -1;
            this.fourthTime = "";
          } else {
            this.fourthTime = data.time;
            this.schClicked4 = index;
            data["branchid"] = this.getBranceId4;
            this.fourthslot.push(data);
          }
          break;
        }
      }

      this.savemultipleArray = [];
      this.savemultipleArray = this.savemultipleArray.concat(
        this.firstslot,
        this.secondslot,
        this.thirdslot,
        this.fourthslot
      );
    }


  }


  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.selectedDoctorName = null;
    this.selectedDoctorName2 = null;
    this.selectedDoctorName3 = null;
    this.selectedDoctorName4 = null;
    this.radioGroup1Value = null;
    this.radioGroup2Value = null;
    this.radioGroup3Value = null;
    this.radioGroup4Value = null;
    this.appservice.doctors = null;
  }





  radioChange(event: MatRadioChange, sectionNumber: number) {
    this.doctortype = event.value;
    switch (sectionNumber) {
      case 1:
        this.getDoctorBrach(this.getBranceId1, 1);
        break;
      case 2:
        this.getDoctorBrach(this.getBranceId2, 2);
        break;
      case 3:
        this.getDoctorBrach(this.getBranceId3, 3);
        break;
      case 4:
        this.getDoctorBrach(this.getBranceId4, 4);
        break;
      default:
        console.error('Invalid section number:', sectionNumber);
        break;
    }
  }

  onDateChange(event) {
    this.doctortype = 6;
    this.getDoctorBrach(this.getBranceId1, 1);
    this.getDoctorBrach(this.getBranceId2, 2);
    this.getDoctorBrach(this.getBranceId3, 3);
    this.getDoctorBrach(this.getBranceId4, 4);
    this.selectedDoctorName = "";
    this.selectedDoctorName2 = "";
    this.selectedDoctorName3 = "";
    this.selectedDoctorName4 = "";
    this.radioGroup1Value = '6';
    this.radioGroup2Value = '6';
    this.radioGroup3Value = '6';
    this.radioGroup4Value = '6';
    this.DoctorCtrl4.setValue('');
    this.DoctorCtrl1.setValue('');
    this.DoctorCtrl2.setValue('');
    this.DoctorCtrl3.setValue('');
    this.firstTime = "";
    this.secondTime = "";
    this.thirdTime = "";
    this.fourthTime = "";
    this.multipleSacheduleArray4 = [];
    this.multipleSacheduleArray3 = [];
    this.multipleSacheduleArray2 = [];
    this.multipleSacheduleArray1 = [];
  }
  failed_doctors(err) {
    this.appservice.doctors = [];
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  clearfields() {
    this.opdvisitService.apptdetail = {};
    this.opdvisitService.apptdetail.initial = "";
    this.oldappoitmentId = 0;
    this.opdvisitService.apptdetail.fkCityId = this.patient_mendatory_fields[0]?.fK_CityId ? this.patient_mendatory_fields[0]?.fK_CityId : null;
    this.opdvisitService.apptdetail.fkConsultantId = 0;
    this.opdvisitService.stateid = 0;
    this.opdvisitService.districtid = 0;
    this.opdvisitService.countryid = 0;
    this.opdvisitService.apptdetail.fkOccupationId = 0;
    this.opdvisitService.apptdetail.fkRefById = 0;
    this.opdvisitService.apptdetail.fkServiceId = 0;
    this.opdvisitService.apptdetail.fkTakenOnId = 0;
    this.opdvisitService.apptdetail.isCancelled = null;
    this.opdvisitService.apptdetail.isSap = null;
    this.opdvisitService.apptdetail.lastName = null;
    this.opdvisitService.apptdetail.firstName = null;
    this.opdvisitService.apptdetail.fkRegId = null;
    // this.opdvisitService.apptdetail.pkAppointmentId = null;
    this.opdvisitService.apptdetail.sex = null;
    this.opdvisitService.apptdetail.address = null;
    this.opdvisitService.apptdetail.ageDays = null;
    this.opdvisitService.apptdetail.ageMonth = null;
    this.opdvisitService.apptdetail.ageYear = null;
    this.opdvisitService.apptdetail.fkForBranchId = null;
    this.opdvisitService.apptdetail.daySrNo = null;
    this.opdvisitService.apptdetail.fkApptTypeId = null;
    this.opdvisitService.apptdetail.dob = null;
    this.opdvisitService.apptdetail.emailAddress = null;
    this.opdvisitService.apptdetail.remarks = null;
    this.opdvisitService.apptdetail.isConfirm = null;
    this.opdvisitService.apptdetail.isCancelled = null;
    this.opdvisitService.apptdetail.tokenNo = null;
    this.opdvisitService.states = [];
    this.opdvisitService.districts = [];
    this.opdvisitService.cities = [];
    this.opdvisitService.areas = [];
    this.opdvisitService.apptdetail.apptTime =
      this.opdvisitService.apptdetail.apptTime;
  }
  convertTo24Hour(s) {
    // var hours = parseInt(time.substr(0, 2));
    // if (time.indexOf('AM') != -1 && hours == 12) {
    //   time = time.replace('12', '0');
    // }
    // if (time.indexOf('PM') != -1 && hours < 12) {
    //   time = time.replace(hours, (hours + 12));
    // }
    // return time.replace(/(AM|PM)/, '');
    var time = s?.split(":");
    var hours = parseInt(time[0]);
    var _ampm = time[1];
    if (_ampm.indexOf("AM") != -1 && hours == 12) {
      time[0] = "00";
    }
    if (_ampm.indexOf("PM") != -1 && hours < 12) {
      time[0] = hours + 12;
    }
    return time.join(":").replace(/(AM|PM)/, "");
  }

  openApointmentDialog(time, isBlock, patientid) {
    if (isBlock == true) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg24"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }
    if (patientid == null) {
      this.opdvisitService.checkpatient = 0;
    } else {
      this.opdvisitService.checkpatient = patientid;
    }

    //CHECK SLOT LIMIT
    this.chkSlot = 0;
    this.ReportedApp = 0;
    for (var var1 of this.appservice.Doctor_time_info_Mod) {
      for (var val of var1.groupItem) {
        if (val.isConfirm == true) {
          //   this.ReportedApp=this.ReportedApp+1;
          //  alert(val.time+" In Confirm "+this.ReportedApp);
        }

        if (val.time == time && val.isCancelled == false) {
          this.chkSlot = this.chkSlot + 1;
          if (this.apptSlotLimit == this.chkSlot && this.isemergency == false) {
            this.chkSlot = 0;
            this.dashboardService.openSnackBar(
              this.authService.appointmentMsg["upgradeMsg.msg25"],
              this.authService.appointmentMsg["Ok"]
            );
            return;
          }
        }
      }
    }

    this.clearfields();
    let now = this.authService.localDate;
    var xHr = now.getHours(); //
    var xMin = now.getMinutes(); //

    //this.datePipe.transform(now,"HH:MM")
    //console.log(xHr);
    //alert(xHr+" date -"+xMin);
    var yTime = this.convertTo24Hour(time);

    this.opdvisitService.appservice.times = time;
    this.opdvisitService.apptdetail.apptTime = time;
    this.opdvisitService.apptdetail.fkConsultantId = parseInt(
      this.appservice.DoctorId
    );
    this.opdvisitService.appSelectDate = this.selectedDate;
    if (
      Date.parse(
        this.datePipe.transform(this.today, "yyyy-MM-dd").toString()
      ) ==
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      //let RealX=xTime.split(":");
      let ApptX = yTime.split(":");

      this.RealTime = xHr * 60 + xMin;
      this.ApptTime = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);

      //alert("Real time-"+this.RealTime+" App time - "+this.ApptTime);
      //if(Date.parse(yTime) < Date.parse(xTime))

      if (this.ApptTime < this.RealTime) {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg3"],
          this.authService.appointmentMsg["Ok"]
        );
        return;
      }
    }
    if (
      Date.parse(this.datePipe.transform(this.today, "yyyy-MM-dd").toString()) >
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg3"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }

    const dialogRef = this.dialog.open(AddappointmentComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      // height: '80%',
      width: "70%",
    });
    this.dashboardService.subscriptions = dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (this.opdvisitService.RefreshCount >= 1) {
        this.opdvisitService.RefreshCount = 0;
        console.log("The dialog was closed");
        this.showRec();
      }
    });
  }

  getLimitcolor(slot: any, booked: any, time: any, cancelledtime: any) {
    if (booked != null && cancelledtime == false) {
      this.chkSlot = 0;
      if (this.appservice.Doctor_time_info_Mod.length > 0) {
        for (var var1 of this.appservice.Doctor_time_info_Mod) {
          for (var val of var1.groupItem) {
            if (
              val.time == time &&
              val.isCancelled == false &&
              booked != null
            ) {
              this.chkSlot = this.chkSlot + 1;
              if (slot == this.chkSlot) {
                this.chkSlot = 0;
                return this.appointmentColorobj.completeslotAppointment;
              }
            }
          }
        }
      }
    }
  }
  showonlyfirst10(fullremark: string, cancelremark: string, istrue) {
    if (fullremark == null && cancelremark == null) {
      return "";
    } else {
      if (cancelremark == null && fullremark != null) {
        return fullremark.substring(0, 20);
      } else if (cancelremark != null && fullremark == null && istrue == true) {
        return "Reason: " + cancelremark.substring(0, 20);
      } else if (cancelremark != null && fullremark != null && istrue == true) {
        let joinstring = fullremark + ". " + "Reason: " + cancelremark;
        return joinstring.substring(0, 20);
      } else if (cancelremark != null && fullremark != null && istrue != true) {
        return fullremark.substring(0, 20);
      } else {
        return "";
      }
    }
  }
  showonlyfirst11(fullremark: string, cancelremark: string, istrue) {
    if (fullremark == null && cancelremark == null) {
      return "";
    } else {
      if (cancelremark == null && fullremark != null) {
        return fullremark;
      } else if (cancelremark != null && fullremark == null && istrue == true) {
        return "Reason: " + cancelremark;
      } else if (cancelremark != null && fullremark != null && istrue == true) {
        return fullremark + ". " + "Reason: " + cancelremark;
      } else if (cancelremark != null && fullremark != null && istrue != true) {
        return fullremark.substring(0, 20);
      } else {
        return "";
      }
    }
  }
  selectionrowdata(data) {
    console.log(data);
  }
  // Appointment tansfer dailog box
  transferAppointment() {
    if (this.opdvisitService.timevalues.length == 1) {
      //  if(this.cancelapp==false){
      if (
        this.opdvisitService.timevalues[0].appId != 0 &&
        this.opdvisitService.timevalues[0].isConfirm != null &&
        this.opdvisitService.timevalues[0].isCancelAppointment != null
      ) {
        if (
          this.opdvisitService.timevalues[0].isConfirm == false &&
          this.opdvisitService.timevalues[0].isCancelAppointment == false
        ) {
          const dialogRef = this.dialog.open(TransferAppointmentComponent, {
            panelClass: "full-width-dialog",

            height: "60%",
            width: "40%",
            data: {
              Appid: this.opdvisitService.timeSingleValue.appId,
              Slottime: this.slottime,
              Doctorid: this.appservice.DoctorId,
              AppointmentNewdate: this.appservice.selectedDate,
              DoctorType: this.doctortype
            },
          });

          this.dashboardService.subscriptions = dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
            this.ApptTime = 0;

            if (result != 0 && result != undefined) {
              this.opdvisitService.timevalues = [];
            }
          });
        } else {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg26"],
            this.authService.appointmentMsg["Ok"]
          );
        }
        // } else {
        //   this.dashboardService.openSnackBar("Please select booked Appointment", "OK");
        //   return;
        // }
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg26"],
          this.authService.appointmentMsg["Ok"]
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg27"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }

  getToolTip(block: any, cancel: any) {
    var tooltip = "";
    if (block != true && cancel != true) {
      tooltip = "";
    }
    return tooltip;
  }

  reschedule: boolean;
  public indexvalue = -1;
  appointmentype: string = "";
  fkschedule: number;
  expandSection(event, i, item, type, serverdatetime: any, sid: number) {
    this.filterreferd = "";
    this.fkschedule = sid;
    this.disabledappointment = false;
    if (this.indexvalue != i) {
      this.onGridslotLimit = item.slotLimit;
      this.addApptonGrid(i, item, type, serverdatetime);
    } else {
      this.closeGrid();
      this.opdvisitService.apptdetail = {};
    }
  }

  //Branch Modal
  branchModalDialog() {
    document.getElementById("branchContainer").style.display = "block";
  }
  closeBranchModalDialog() {
    document.getElementById("branchContainer").style.display = "none";
  }

  //Doctor Name Modal
  doctorNameModalDialog() {
    document.getElementById("doctorNameModal").style.display = "block";
  }
  closedoctorNameModalDialog() {
    document.getElementById("doctorNameModal").style.display = "none";
  }

  //SMS Template Modal
  SMSTemplateModalDialog() {
    document.getElementById("SMSTemplateModal").style.display = "block";
  }
  closeSMSTemplateModalDialog() {
    document.getElementById("SMSTemplateModal").style.display = "none";
    this.getSMStemplate();
    this.searchtep = '';
  }

  //Success Modal
  successModalDialog() {
    document.getElementById("successModal").style.display = "block";
  }
  closeSuccessModalDialog() {
    document.getElementById("successModal").style.display = "none";
  }

  //Available Slots
  availableSlotsModalDialog() {
    // document.getElementById("availableSlotsModal").style.display = "block";
  }
  closeAvailableSlotsModalDialog() {
    document.getElementById("availableSlotsModal").style.display = "none";
  }

  //Holiday Modal
  checkholidaybranch(value, type) {
    if (!value && type == 0) {
      this.holidaybranchid = 0;
      this.getHolidaydata(this.holidaybranchid, this.holidayyears, 0);
    } else if (!value && type == 1) {
      this.holidayyears = null;
      // this.getHolidaydata(this.holidaybranchid,this.holidayyears,0);
    }
  }
  holidaybranchid: number = 0;
  holidayyears: any = 0;
  GetbranchbyId(event, type) {
    if (type == 0) {
      this.holidaybranchid = event.option.id;
      this.getHolidaydata(this.holidaybranchid, this.holidayyears, 0);
    } else if (type == 1) {
      this.holidayyears = event.option.value;
      this.getHolidaydata(this.holidaybranchid, this.holidayyears, 0);
    }

  }
  AddHolidays() {
    if (this.holidaybranchid > 0) {
      const branchdata = this.branchlist.filter(item => item.pkBranchId == this.holidaybranchid);
      var newdata = {
        "pK_TranID": 0,
        "fK_BranchID": this.holidaybranchid,
        "holidayDate": this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd"),
        "holidayName": null,
        "isActive": true,
        "isEdit": false,
        "branchName": branchdata[0]?.branchName,
        "branchCode": branchdata[0]?.branchCode
      }
      if (this.brachholidayMaster.length > 0) {
        let checknewdata = this.brachholidayMaster.filter(item => item.pK_TranID == 0);
        if (checknewdata.length > 0) {
          this.dashboardService.openSnackBar("New Row Already Added", "OK");
        } else {
          var newarray = [];
          newarray.push(newdata);
          this.brachholidayMaster = this.brachholidayMaster.concat(newarray);
        }

      } else {
        var newarray = [];
        newarray.push(newdata);
        this.brachholidayMaster = this.brachholidayMaster.concat(newarray);
      }
      this.holidayinputRef.changes.pipe(take(1)).subscribe({
        next: changes => changes.last.nativeElement.focus()
      })
    } else {
      this.dashboardService.openSnackBar("Please Select Branch", "OK");
    }
  }

  Edit(index) {
    this.brachholidayMaster[index].isEdit = true;
  }
  brachholidayMaster: HolidayMasterModel[] = [];
  years: number[] = [];
  holidayMasterModal() {
    this.holidaybranchid = 0;
    this.branchCtrl1.setValue('');
    for (let i = 2000; i <= 2100; i++) {
      this.years.push(i);
    }
    this.holidayyears = new Date(this.authService.localDate).getFullYear();
    this.getHolidaydata(this.holidaybranchid, this.holidayyears, 0)
    this.filteredyearsArray = this.yearsCtrl.valueChanges.pipe(
      startWith(""),
      map((item) => item ? this.filteryearsfunction(item) : this.years.slice()
      )
    );
  }
  filteryearsfunction(name: any) {
    return this.years.filter(
      (e) => e.toString().indexOf(name) === 0
    );
  }
  chageholidayName(value, i) {
    this.brachholidayMaster[i].holidayName = value;
  }
  chageholidaydate(value, i) {
    this.brachholidayMaster[i].holidayDate = value;
  }

  deleteHoliday(row) {
    let payload = {
      "HolidayMaster": {
        "pK_TranID": row.pK_TranID,
        "fK_BranchID": row.fK_BranchID,
        "holidayDate": this.datePipe.transform(row.holidayDate, "yyyy-MM-dd"),
        "holidayName": row.holidayName,
        "isActive": false,
        "isEdit": true,
        "branchName": row.branchName,
        "branchCode": row.branchCode,
      }
    }
    this.dashboardService.subscriptions = this.appservice.insertHolidayMaster(payload).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {

      this.dashboardService.openSnackBar("Record Deleted Successfully", "ok");

      this.getHolidaydata(this.holidaybranchid, this.holidayyears, 0);
    }, err => {
      this.dashboardService.openSnackBar("API Failed", "ok");
    });
  }

  isSaving: boolean = false;
  saveEdit(i) {
    if (this.isSaving) return;
    this.isSaving = true;

    const savedata = this.brachholidayMaster.filter(item => item.pK_TranID == 0 || item.isEdit == true);

    if (savedata.length > 0) {
      if (savedata[0].holidayName) {
        const checkdublicate = this.brachholidayMaster.filter(item =>
          item.holidayName.toLowerCase() == savedata[0].holidayName.toLowerCase()
        );

        const checkDuplicateDateAndBranch = this.brachholidayMaster.filter(item =>
          item.fK_BranchID == savedata[0].fK_BranchID &&
          this.datePipe.transform(item.holidayDate, "yyyy-MM-dd") == this.datePipe.transform(savedata[0].holidayDate, "yyyy-MM-dd")
        );

        if (checkDuplicateDateAndBranch.length > 1) {
          this.dashboardService.openSnackBar("Duplicate Holiday Date for the Same Branch Not Allowed", "Ok");
          this.isSaving = false;
          return;
        }

        if (checkdublicate.length == 1) {
          let payload = {
            "HolidayMaster": {
              "pK_TranID": savedata[0].pK_TranID,
              "fK_BranchID": savedata[0].fK_BranchID,
              "holidayDate": this.datePipe.transform(savedata[0].holidayDate, "yyyy-MM-dd"),
              "holidayName": savedata[0].holidayName,
              "isActive": true,
              "isEdit": savedata[0].pK_TranID > 0 ? true : false,
              "branchName": savedata[0]?.branchName,
              "branchCode": savedata[0]?.branchCode,
            }
          };

          this.dashboardService.subscriptions = this.appservice.insertHolidayMaster(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe((x: any) => {
              this.isSaving = false;
              if (x.statusCode == 8 || x.statusCode == 7) {
                this.dashboardService.openSnackBar("Please Transfer Your booked Appointment to Another Days", "ok");
              } else {
                if (savedata[0].pK_TranID > 0) {
                  this.dashboardService.openSnackBar("Record Updated Successfully", "ok");
                } else {
                  this.dashboardService.openSnackBar("Record Saved Successfully", "ok");
                }
                this.getHolidaydata(this.holidaybranchid, this.holidayyears, 0);
              }
            }, err => {
              this.isSaving = false;
              this.dashboardService.openSnackBar("API Failed", "ok");
            });

        } else {
          this.dashboardService.openSnackBar("Duplicate Record Not Allowed", "ok");
          this.isSaving = false;
        }
      } else {
        this.dashboardService.openSnackBar("Holiday Name Required", "ok");
        this.isSaving = false;
      }
    }
  }

  getHolidaydata(branchid, years, type) {
    if (years) {
      this.dashboardService.subscriptions = this.appservice.holidayMasterbybranchid(branchid, years).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.brachholidayMaster = [];
        this.brachholidayMaster = x;
        if (type == 0) {
          document.getElementById("holidayMasterModal").style.display = "block";
        }
      }, err => {
        this.dashboardService.openSnackBar("API Failed", "OK");
      })
    } else {
      this.dashboardService.openSnackBar("Please Select year", "OK");
    }

  }
  closeHolidayMasterModal() {

    document.getElementById("holidayMasterModal").style.display = "none";
  }
  drSummeryallDates: any
  //Doctor Summary Modal
  doctorSummaryModal() {
    this.drSummeryallDates = [];
    this.subspeciltyid = 0;
    this.subsepecialityName = null;
    this.RefreshDoctorsummery();
    // this.drSummeryallDates = this.getAllDates(moment(this.fromDateDrSummery), moment(this.toDateDrSummery));
    this.getSubsepecitry();
    // this.GetDoctorAppointmentSu();
    this.getdrHeader();
    document.getElementById("doctorSummaryModal").style.display = "block";

  }
  closeDoctorSummaryModal() {
    this.drchecklistClicked = -1;
    this.drSummeryallDates = [];
    this.newdataArray = [];
    this.doctorsummeryArray = [];
    this.drSummeryheader = [];
    document.getElementById("doctorSummaryModal").style.display = "none";
  }

  //Reschedule Template Modal
  RescheduleModalDialog(
    event,
    ids,
    time,
    confirm,
    cappointment,
    pname,
    mnumber,
    rowdata: any
  ) {
    event.checked = true;
    this.rescheduleapp = true;
    this.rowdata = rowdata;
  }

  rescheduleonGrid(selectApp) {
    if (this.rescheduleapp == true) {
      if (
        selectApp.appId != 0 &&
        selectApp.isConfirm != null &&
        selectApp.isCancelled != null
      ) {
        if (selectApp.isConfirm == false && selectApp.isCancelled == false) {
          // document.getElementById("rescheduleModal").style.display = "block";
          this.ongridReschedule = true;
          const dialogRef = this.dialog.open(TransferAppointmentComponent, {
            panelClass: "full-width-dialog",
            height: "auto",
            width: "50%",
            data: {
              Appid: selectApp.appId,
              Slottime: selectApp.time,
              Doctorid: this.appservice.DoctorId,
              AppointmentNewdate: selectApp.scheduleDate,
              onGrid: this.ongridReschedule,
              DoctorType: this.doctortype
            },
          });

          this.dashboardService.subscriptions = dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
            this.ApptTime = 0;
            if (result == 1) {
              this.selectMeALL(this.appservice.doctors[0]);
            }
          });
        } else {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg26"],
            this.authService.appointmentMsg["Ok"]
          );
        }
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg26"],
          this.authService.appointmentMsg["Ok"]
        );
      }
    } else {
      alert("f");
    }
  }
  // closeRescheduleModalDialog() {
  //   document.getElementById("rescheduleModal").style.display = "none";
  // }

  selectBranchid(branchitem) {
    console.log(branchitem);
    this.apptbranchid = branchitem.pkBranchId;
    this.apptbranchname = branchitem.branchName;
    this.closeBranchModalDialog();
  }
  branchList() {
    this.dashboardService.subscriptions = this.appservice.getBrachMaster().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      let branchitemlist = data;
      let branchfilter = branchitemlist.filter(
        (item) => item.pkBranchId == this.apptbranchid
      );
      this.apptbranchname = branchfilter[0].branchName;
      if (branchitemlist.length != 0) {
        this.branchlist = branchitemlist.filter(
          (item) => item.isActive == true
        );
        this.branchdataSource.data = this.branchlist;
        this.branchControll();
        this.branchControlldata();
      }
    });
  }
  getPatientAppts() {

    this.dashboardService.subscriptions = this.appservice
      .getAppointmentList(
        this.apptbranchid,
        this.selectedAppListDate,
        this.appservice.FK_DoctorId,
        this.ReportingStatus,
        this.CancelStatus
      ).pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.appdataSource.data = data;
      });
  }
  getreporting() {
    this.dashboardService.subscriptions = this.appservice.getReportingType().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.reportingData = data;
      if (this.reportingData != 0) {
        this.reportControll();
      }
    });
  }
  getcancel() {
    this.dashboardService.subscriptions = this.appservice.getReportCancel().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.cancellistdata = data;
      if (this.cancellistdata != 0) {
        this.cancelControll();
      }
    });
  }

  getTemplate(id) {
    this.dashboardService.subscriptions = this.appservice.getTempMaster(id).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      let templatearylist = data;
      if (templatearylist != 0) {
        this.templatelist = templatearylist.filter(
          (item) => item.isActive == true
        );
        this.templateControll();
        console.log(this.templatelist);
      }
    });
  }

  apptexportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById("contentapp");
    this.exportdata.Newexportxcel(element, "Appointment_List");
  }

  ClickedRow(selectid, index) {
    this.apptPatientId = selectid;
    this.HighlightRow = index;
  }
  opendocdialog(): void {
    if (
      this.apptPatientId?.patientId != undefined &&
      this.apptPatientId?.patientId != null
    ) {
      if (this.apptPatientId?.patientId == 0) {
        this.dashboardService.openSnackBar(
          "This Patient Is Not Registered.",
          "ok"
        );
      } else {
        let patinfo = this.apptPatientId;
        this.opdvisitService.patientdetails.pkRegId =
          this.apptPatientId.patientId;
        const dialogRef = this.dialog.open(PatientdocsComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "80%",
          width: "50%",
          data: {
            patID: patinfo.patientId,
            patinit: patinfo.initial,
            patFname: patinfo.firstName,
            patLname: patinfo?.lastName,
          },
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
          console.log("The dialog was closed");
        });
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg28"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }

  doctorControll() {
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterdoctorfunction(cat)
          : this.appservice.doctors.slice()
      )
    );
  }

  filterdoctorfunction(name: string) {
    return this.appservice.doctors.filter(
      (country) =>
        country.userName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  reportControll() {
    this.filteredreportArray = this.reportCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item ? this.filterreportfunction(item) : this.reportingData.slice()
      )
    );
  }
  filterreportfunction(name: string) {
    return this.reportingData.filter(
      (item) => item.status.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  cancelControll() {
    this.filteredcancelArray = this.cancelCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item ? this.filtercancelfunction(item) : this.cancellistdata.slice()
      )
    );
  }
  filtercancelfunction(name: string) {
    return this.cancellistdata.filter(
      (e) => e.status.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  templateControll() {
    this.filteredtemplateArray = this.templateCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item ? this.filtertemplatefunction(item) : this.templatelist.slice()
      )
    );
  }
  filtertemplatefunction(name: string) {
    return this.templatelist.filter(
      (e) => e.smsType.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }
  branchControll() {
    this.filteredbranchArray = this.branchCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item ? this.filterbranchfunction(item) : this.branchlist.slice()
      )
    );
  }
  filterbranchfunction(name: string) {
    return this.branchlist.filter(
      (e) => e.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  branchControlldata() {
    this.filteredbranchArray1 = this.branchCtrl1.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item ? this.filterbranchfunction1(item) : this.branchlist.slice()
      )
    );
  }
  filterbranchfunction1(name: string) {
    return this.branchlist.filter(
      (e) => e.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }
  selectPatient(event, item) {
    this.apptPatientId = item;
  }
  sendMessage() {
    if (this.selection.selected.length > 0) {
      let contactNo;
      let messagesend;
      this.selection.selected.forEach((item) => {
        contactNo = item.contactNo;
        if (contactNo.length == 10) {
          let payload = {
            BranchId: this.apptbranchid,
            MobileNo: contactNo,
            SMSType: this.seletedTemp,
          };
          this.dashboardService.subscriptions = this.authService.userMobileOTP(payload).subscribe((data) => {
            messagesend = data;
            if (messagesend.statusCode == 1) {
              this.dashboardService.openSnackBar(
                this.authService.appointmentMsg["upgradeMsg.msg29"],
                this.authService.appointmentMsg["Ok"]
              );
            }
          });
        }
      });
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg28"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.appdataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.appdataSource.data?.forEach((row) => this.selection.select(row));
  }
  selectRow(row, index) {
    this.apptPatientId = row;
    this.HighlightRow = index;
  }

  searchFilter(filterValue) {
    this.appdataSource.filter = filterValue.trim().toLowerCase();
  }

  branchFilter(filterValue) {
    this.branchdataSource.filter = filterValue.trim().toLowerCase();
  }

  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onTabSelectionChanged(event: any) {

    if (event == 0) {
      this.doctortype = 6;
      this.getDoctorBrach(this.getBranceId, 0);
    } else {
      this.doctortype = 8;
      this.getDoctorBrach(this.getBranceId, 0);
    }

  }
  onMainTabSelectionChanged(event: any) {
    if (event == 4) {
      this.opdvisitService.apptdetail.fkRegId = null;
      this.opdvisitService.apptdetail.initial = null;
      this.opdvisitService.apptdetail.sex = null;
      this.opdvisitService.apptdetail.fkTakenOnId = 0;
      this.opdvisitService.apptdetail.pkAppointmentId = 0;
      this.opdvisitService.apptdetail.isCancelled = "false";
      this.opdvisitService.apptdetail.IsEmergencyAppt = false;
      this.opdvisitService.apptdetail.isActive = true;
      this.opdvisitService.apptdetail.isConfirm = "false";
      this.opdvisitService.apptdetail.fkCity = this.patient_mendatory_fields[0]?.fK_CityId ? this.patient_mendatory_fields[0]?.fK_CityId : null;
      this.opdvisitService.apptdetail.daySrNo = 1;
      this.opdvisitService.apptdetail.tokenNo = 1;
      this.opdvisitService.apptdetail.fkCreatedById =
        this.authService.Loggeduser.userid
      this.opdvisitService.apptdetail.fkRefById =
        this.opdvisitService.personmaster[0]?.pkPersonId;
      this.opdvisitService.apptdetail.fkServiceId = 0;
      const findName = this.opdvisitService.personmaster.filter(
        (item) => item.pkPersonId == this.opdvisitService.apptdetail.fkRefById
      );
      if (findName.length > 0) {
        this.filterreferd = findName[0]?.personName;
      } else {
        this.filterreferd = null;
      }
      if (this.apptList.length > 0) {
        this.opdvisitService.apptdetail.fkApptTypeId =
          this.apptList[0].apptTypeId;
      } else {
        this.opdvisitService.apptdetail.fkApptTypeId = null;
      }

      this.DoctorCtrl1.setValue(null);
      this.DoctorCtrl2.setValue(null);
      this.DoctorCtrl3.setValue(null);
      this.DoctorCtrl4.setValue(null);
      this.doctorControll1();
      this.doctorControll2();
      this.doctorControll3();
      this.doctorControll4();
      this.multipleSacheduleArray1 = [];
      this.multipleSacheduleArray2 = [];
      this.multipleSacheduleArray3 = [];
      this.multipleSacheduleArray4 = [];
      this.firstTime = null;
      this.secondTime = null;
      this.thirdTime = null;
      this.fourthTime = null;
      this.selectedDoctorName = ''
      this.selectedDoctorName2 = ''
      this.selectedDoctorName3 = ''
      this.selectedDoctorName4 = ''
      this.schClicked = -1;
      this.schClicked2 = -1;
      this.schClicked3 = -1;
      this.schClicked4 = -1;
    } else if (event == 3) {
      
      this.getSMStemplate();
      this.initializeConsDrControl();
      this.getConusellorStatus();
      this.doctorlist = this.authService.users.filter(item => item.fkUserTypeId == 6 || item.fkUserTypeId == 5);
    }
  }
  checkApptType() {
    if (this.addApptType == "apptNew") {
      let patMobile = this.opdvisitService.oldPatDetails.mobileNo;
      let fname = this.opdvisitService.oldPatDetails.firstName;
      let lname = this.opdvisitService.oldPatDetails.lastName;
      let patGebder = this.opdvisitService.oldPatDetails.sex;
      let patdob = this.datePipe.transform(
        this.opdvisitService.oldPatDetails.dob,
        "yyyy-MM-dd"
      );
      if (
        fname != this.opdvisitService.apptdetail.firstName ||
        lname != this.opdvisitService.apptdetail.lastName ||
        patGebder != this.opdvisitService.apptdetail.sex ||
        patdob != this.opdvisitService.apptdetail.dob
      ) {
        this.opdvisitService.apptdetail.fkRegId = null;
      } else if (
        patMobile != this.opdvisitService.apptdetail.mobileNo &&
        patMobile != null
      ) {
        this.opdvisitService.apptdetail.fkRegId = null;
      } else {
        this.opdvisitService.apptdetail.fkRegId =
          this.opdvisitService.oldPatDetails.pkRegId;
      }
    }
  }

  opensearchPtDialog(): void {
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.checkshort = true;
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      disableClose: true,
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      width: "90%",
      data: [{ TempShow: true, Type: 1 }],
    });

    this.dashboardService.subscriptions = dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {

      if (result > 0 || this.opdvisitService.patientdetails.pkRegId > 0) {
        this.disabledappointment = false;
        this.opdvisitService.getappdetails(
          this.opdvisitService.patientdetails.pkRegId
        );
      }
    });
  }

  closeGrid() {
    this.reschedule = false;
    this.indexvalue = -1;
  }
  addApptonGrid(i, item, apptType, serverdatetime: any) {
    let time = item.time;
    let isBlock = item.isBlock;
    let patientid = item.patientId;
    let editapptId = item.appId;
    this.addApptType = apptType;

    if (isBlock == true) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg24"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    }
    if (patientid == null) {
      this.opdvisitService.checkpatient = 0;
    } else {
      this.opdvisitService.checkpatient = patientid;
    }
    if (apptType == "apptNew") {
      this.appointmentype = "apptNew";
      this.chkSlot = 0;
      this.ReportedApp = 0;
      this.slotcount = this.chkSlot;
      for (var var1 of this.appservice.Doctor_time_info_Mod) {
        for (var val of var1.groupItem) {
          if (val.isConfirm == true) {
          }

          if (val.time == time && val.isCancelled == false) {
            this.chkSlot = this.chkSlot + 1;
            this.slotcount = this.chkSlot;
            if (
              this.apptSlotLimit == this.chkSlot &&
              this.isemergency == false
            ) {
              this.chkSlot = 0;
              this.dashboardService.openSnackBar(
                this.authService.appointmentMsg["upgradeMsg.msg25"],
                this.authService.appointmentMsg["Ok"]
              );
              return;
            }
          }
        }
      }
    } else {
      this.chkSlot = 0;
      for (var var1 of this.appservice.Doctor_time_info_Mod) {
        for (var val of var1.groupItem) {
          if (val.time == time && val.isCancelled == false) {
            this.chkSlot = this.chkSlot + 1;
            this.slotcount = this.chkSlot;
          }
        }
      }
    }

    this.clearfields();
    let now = serverdatetime;
    var xHr = now.getHours(); //
    var xMin = now.getMinutes(); //

    var yTime = this.convertTo24Hour(time);

    this.opdvisitService.appservice.times = time;
    this.opdvisitService.apptdetail.apptTime = time;
    this.opdvisitService.apptdetail.fkConsultantId = parseInt(
      this.appservice.DoctorId
    );
    this.opdvisitService.appSelectDate = this.selectedDate;
    if (
      Date.parse(
        this.datePipe.transform(this.today, "yyyy-MM-dd").toString()
      ) ==
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      //let RealX=xTime.split(":");
      let ApptX = yTime.split(":");

      this.RealTime = xHr * 60 + xMin;
      this.ApptTime = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);

      //alert("Real time-"+this.RealTime+" App time - "+this.ApptTime);
      //if(Date.parse(yTime) < Date.parse(xTime))

      if (this.ApptTime < this.RealTime) {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg3"],
          this.authService.appointmentMsg["Ok"]
        );
        return;
      } else {
        if (this.defaultautoRef) {
          setTimeout(() => {
            this.defaultautoRef.nativeElement.focus();
          }, 200);
        }

        this.indexvalue = i;
      }
    }
    if (
      Date.parse(this.datePipe.transform(this.today, "yyyy-MM-dd").toString()) >
      Date.parse(
        this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString()
      )
    ) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg3"],
        this.authService.appointmentMsg["Ok"]
      );
      return;
    } else {
      if (this.defaultautoRef) {
        setTimeout(() => {
          this.defaultautoRef.nativeElement.focus();
        }, 200);
      }

      this.indexvalue = i;
    }

    if (apptType == "apptEdit") {
      this.appointmentype = "apptEdit";
      this.oldappoitmentId = editapptId;
      this.dashboardService.subscriptions = this.opdvisitService
        .getappointmentbyId(editapptId).pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
          this.opdvisitService.apptdetail = result;
          this.opdvisitService.apptdetail.mobileNo = result.contactNo;
          this.opdvisitService.apptdetail.dob = this.datePipe.transform(
            result.dob,
            "yyyy-MM-dd"
          );
          const findName = this.opdvisitService.personmaster.filter(
            (item) =>
              item.pkPersonId == this.opdvisitService.apptdetail.fkRefById
          );
          if (findName.length > 0) {
            this.filterreferd = findName[0]?.personName;
          } else {
            this.filterreferd = this.opdvisitService.apptdetail.fkRefBy;
          }
        });
      // this.opdvisitService.getappdetails(patientid);
    } else {
      this.opdvisitService.apptdetail.initial = null;
      this.opdvisitService.apptdetail.sex = null;
      this.opdvisitService.apptdetail.fkTakenOnId = 0;
      this.opdvisitService.apptdetail.fkRefById =
        this.opdvisitService.personmaster[0]?.pkPersonId;
      const findName = this.opdvisitService.personmaster.filter(
        (item) => item.pkPersonId == this.opdvisitService.apptdetail.fkRefById
      );
      if (findName.length > 0) {
        this.filterreferd = findName[0]?.personName;
      } else {
        this.filterreferd = null;
      }
      if (this.isemergency == false) {
        if (this.apptList.length > 0) {
          this.opdvisitService.apptdetail.fkApptTypeId =
            this.apptList[0].apptTypeId;
        } else {
          this.opdvisitService.apptdetail.fkApptTypeId = null;
        }
      } else {
        if (this.apptList.length > 0) {
          let emg = this.apptList.filter(
            (item) => item.apptType.toLowerCase() == "emergency"
          );
          if (emg.length > 0) {
            this.opdvisitService.apptdetail.fkApptTypeId = emg[0].apptTypeId;
          } else {
            this.opdvisitService.apptdetail.fkApptTypeId = null;
          }
        } else {
          this.opdvisitService.apptdetail.fkApptTypeId = null;
        }
      }
    }
    this.reschedule = true;
  }

  ngAfterViewChecked() {
    if (this.isemergency == true) {
      if (this.apptList.length > 0) {
        let emg = this.apptList.filter(
          (item) => item.apptType.toLowerCase() == "emergency"
        );
        if (emg.length > 0) {
          this.opdvisitService.apptdetail.fkApptTypeId = emg[0].apptTypeId;
        } else {
          this.opdvisitService.apptdetail.fkApptTypeId = null;
        }
      } else {
        this.opdvisitService.apptdetail.fkApptTypeId = null;
      }
    }
  }
  patientid: number = 0;
  changedata(value: any) {
    if (this.opdvisitService.apptdetail.fkRegId > 0) {
      this.patientid = this.opdvisitService.apptdetail.fkRegId;
      document.getElementById("SameappointConsultasion").style.display =
        "block";
    }
  }
  closesConsultationAppintment() {
    this.disabledappointment = true;
    this.opdvisitService.getappdetails(this.patientid);
    document.getElementById("SameappointConsultasion").style.display = "none";
  }
  submitConsultation() {
    this.opdvisitService.apptdetail.fkRegId = null;
    this.disabledappointment = false;
    document.getElementById("SameappointConsultasion").style.display = "none";
  }
  saveRescheduleAppt() {

    this.opdvisitService.apptdetail.IsEmergencyAppt = this.isemergency;
    this.opdvisitService.apptdetail.FK_ScheduleTypeId = this.fkschedule;
    if (this.opdvisitService.apptdetail.ageYear <= 200) {
      if (
        this.opdvisitService.apptdetail.fkServiceId == 0 ||
        this.opdvisitService.apptdetail.fkServiceId == null ||
        this.opdvisitService.apptdetail.fkServiceId == undefined
      ) {
        this.opdvisitService.apptdetail.fkServiceId = 0;
      }
      const currrentdate = this.authService.localDate;
      if (
        Date.parse(
          this.datePipe.transform(currrentdate, "yyyy-MM-dd").toString()
        ) ==
        Date.parse(
          this.datePipe
            .transform(this.opdvisitService.appSelectDate, "yyyy-MM-dd")
            .toString()
        )
      ) {
        let xHr = currrentdate.getHours();
        let xMin = currrentdate.getMinutes();
        let yTime = this.convertTo24Hour(
          this.opdvisitService.apptdetail.apptTime
        );
        let ApptX = yTime.split(":");

        let RealTime = xHr * 60 + xMin;
        let ApptTime = parseInt(ApptX[0]) * 60 + parseInt(ApptX[1]);
        if (ApptTime < RealTime) {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg18"],
            this.authService.appointmentMsg["Ok"]
          );
        } else {
          this.opdvisitService.showspinner = true;
          // this.open_loader_Dialog();
          if (
            this.opdvisitService.apptdetail.pkAppointmentId == 0 ||
            this.opdvisitService.apptdetail.pkAppointmentId == null ||
            this.opdvisitService.apptdetail.pkAppointmentId == undefined
          ) {
            this.opdvisitService.apptdetail.pkAppointmentId = 0;
          }
          if (
            this.opdvisitService.apptdetail.pkAppointmentId == 0 &&
            this.oldappoitmentId == 0
          ) {
            this.GetMoreApptCount();
          } else {
            this.opdvisitService.apptdetail.pkAppointmentId =
              this.oldappoitmentId;
            this.opdvisitService.updateappt(this.getBranceId);
            this.closeGrid();
            this.oldappoitmentId = 0;
          }
        }
      } else {
        // this.open_loader_Dialog();
        this.opdvisitService.showspinner = true;
        if (
          this.opdvisitService.apptdetail.pkAppointmentId == 0 ||
          this.opdvisitService.apptdetail.pkAppointmentId == null ||
          this.opdvisitService.apptdetail.pkAppointmentId == undefined
        ) {
          this.opdvisitService.apptdetail.pkAppointmentId = 0;
        }

        if (
          this.opdvisitService.apptdetail.pkAppointmentId == 0 &&
          this.oldappoitmentId == 0
        ) {
          this.GetMoreApptCount();
        } else {

          this.opdvisitService.apptdetail.pkAppointmentId =
            this.oldappoitmentId;
          this.opdvisitService.updateappt(this.getBranceId);
          this.closeGrid();
          this.oldappoitmentId = 0;
        }
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg30"],
        this.authService.appointmentMsg["Ok"]
      );
    }
  }

  GetMoreApptCount() {

    var appointmentdata;
    if (this.appservice.docotrSlot.length != 0) {
      var checkappointmentPatient;
      checkappointmentPatient = this.appservice.docotrSlot.filter(
        (item) =>
          item.patientId == this.opdvisitService.apptdetail.fkRegId &&
          item.isCancelled == false
      );
      if (checkappointmentPatient.length != 0) {
        appointmentdata = checkappointmentPatient[0].patientId;
      } else {
        appointmentdata = null;
      }
    } else {
      appointmentdata = null;
    }

    if (
      appointmentdata != this.opdvisitService.apptdetail.fkRegId ||
      appointmentdata == null
    ) {
      if (this.opdvisitService.apptdetail.fkRegId != null) {
        this.dashboardService.subscriptions = this.opdvisitService.getfutureAppt().pipe(takeUntil(this.destroy$)).subscribe(
          (data) => this.success_count(data),
          (err) => this.error_count(err)
        );
      } else {
        this.opdvisitService.saveapptdetails(this.getBranceId);
        this.closeGrid();
      }
    } else {
      // this.opdvisitService.updateappt();
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg31"],
        this.authService.appointmentMsg["Ok"]
      );
      this.closeGrid();
      this.opdvisitService.showspinner = false;
    }
  }
  success_count(data) {
    // alert("working till here");
    this.opdvisitService.showspinner = false;
    this.opdvisitService.futureApptCount = data;
    if (this.opdvisitService.futureApptCount > 0) {
      this.dashboardService.openSnackBar(
        this.authService.appointmentMsg["upgradeMsg.msg32"],
        this.authService.appointmentMsg["Ok"]
      );
      this.opdvisitService.futureApptCount = 0;
      this.opdvisitService.saveapptdetails(this.getBranceId);
      this.closeGrid();
    } else {
      this.opdvisitService.saveapptdetails(this.getBranceId);
      this.closeGrid();
    }
  }
  error_count(err) {
    this.closeGrid();
    this.opdvisitService.showspinner = false;
  }
  reMovedata(event) {
    this.disabledappointment = false;
    if (event == "" && this.appointmentype == "apptNew") {
      const apptTimeToRetain = this.opdvisitService.apptdetail.apptTime;
      const idtoRequired = this.opdvisitService.apptdetail.fkConsultantId;
      const occupation = this.opdvisitService.apptdetail.fkOccupationId
      const fkrefbyId = this.opdvisitService.apptdetail.fkRefById
      this.opdvisitService.apptdetail = {
        apptTime: apptTimeToRetain,
        fkConsultantId: idtoRequired,
        fkOccupationId: occupation,
        fkRefById: fkrefbyId
      };
    }
  }

  getdob(type: any) {
    switch (type) {
      case 1: {
        var tdate = this.authService.localDate;
        if (
          this.opdvisitService.apptdetail.ageYear == null ||
          this.opdvisitService.apptdetail.ageYear == undefined
        ) {
          this.opdvisitService.apptdetail.ageYear = 0;
        }
        this.opdvisitService.apptdetail.ageMonth = 0;
        this.opdvisitService.apptdetail.ageDays = 0;
        tdate.setDate(
          tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays
        );
        tdate.setMonth(
          tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth
        );
        tdate.setFullYear(
          tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear
        );
        this.opdvisitService.apptdetail.dob = this.datePipe.transform(
          tdate,
          "yyyy-MM-dd"
        );
        break;
      }
      case 2: {
        var tdate = this.authService.localDate;
        if (
          this.opdvisitService.apptdetail.ageMonth > 11 ||
          this.opdvisitService.apptdetail.ageMonth <= 0
        ) {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg33"],
            this.authService.appointmentMsg["Ok"]
          );
          this.opdvisitService.apptdetail.ageMonth = null;
          return false;
        }
        if (
          this.opdvisitService.apptdetail.ageYear == undefined ||
          this.opdvisitService.apptdetail.ageYear == null
        ) {
          this.opdvisitService.apptdetail.ageYear = 0;
        }
        this.opdvisitService.apptdetail.ageDays = 0;
        tdate.setDate(
          tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays
        );
        tdate.setMonth(
          tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth
        );
        tdate.setFullYear(
          tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear
        );
        this.opdvisitService.apptdetail.dob = this.datePipe.transform(
          tdate,
          "yyyy-MM-dd"
        );
        break;
      }
      case 3: {
        var tdate = this.authService.localDate;
        if (
          this.opdvisitService.apptdetail.ageDays > 31 ||
          this.opdvisitService.apptdetail.ageDays < 0
        ) {
          this.dashboardService.openSnackBar(
            this.authService.appointmentMsg["upgradeMsg.msg34"],
            this.authService.appointmentMsg["Ok"]
          );
          this.opdvisitService.apptdetail.ageDays = null;
          return false;
        }
        if (
          (this.opdvisitService.apptdetail.ageMonth == undefined ||
            this.opdvisitService.apptdetail.ageMonth == null) &&
          (this.opdvisitService.patientdetails.ageYear == undefined ||
            this.opdvisitService.patientdetails.ageYear == null)
        ) {
          this.opdvisitService.apptdetail.ageMonth = 0;
          this.opdvisitService.apptdetail.ageYear = 0;
        }
        tdate.setDate(
          tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays
        );
        tdate.setMonth(
          tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth
        );
        tdate.setFullYear(
          tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear
        );
        this.opdvisitService.apptdetail.dob = this.datePipe.transform(
          tdate,
          "yyyy-MM-dd"
        );
      }
    }

    // console.log("new date " + this.opdvisitService.apptdetail.dob);
  }
  getage(selecteddate: string) {
    const checkcdate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let currentdate = this.authService.getServerDate;
    if (currentdate >= checkcdate) {
      this.getDataDiff(new Date(selecteddate), new Date(currentdate));
    } else {
      this.opdvisitService.apptdetail.dob = this.datePipe.transform(
        this.authService.getServerDate,
        "yyyy-MM-dd"
      );
      this.opdvisitService.apptdetail.ageYear = 0;
      this.opdvisitService.apptdetail.ageMonth = 0;
      this.opdvisitService.apptdetail.ageDays = 0;
    }
  }
  getToday(): string {
    return this.authService.localDate.toISOString().split("T")[0];
  }
  getDataDiff(start, end) {
    let years: number = 0,
      months: number = 0,
      days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (
      end.getMonth() < start.getMonth() ||
      (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())
    ) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.opdvisitService.apptdetail.ageYear = years;
    this.opdvisitService.apptdetail.ageMonth = months;
    this.opdvisitService.apptdetail.ageDays = days;
  }

  Validate_firstName() {
    if (this.patient_mendatory_fields[0].mandatoryFirstName == true) {
      if (
        this.opdvisitService.apptdetail.firstName == null ||
        this.opdvisitService.apptdetail.firstName == ""
      ) {
        this.ValidatefirstName = true;
        this.user_validated =
          this.user_validated +
          " " +
          this.authService.appointmentMsg["upgradeMsg.msg35"] +
          " \n";
      }
    }
  }
  Validate_lastName() {
    if (this.patient_mendatory_fields[0].mandatoryLastName == true) {
      if (this.opdvisitService.apptdetail.lastName == null || this.opdvisitService.apptdetail.lastName == "") {
        this.ValidatelastName = true;
        this.user_validated = this.user_validated + " " + "Last Name, " + " \n";
      }
    }
  }
  Validate_appType() {
    if (this.opdvisitService.apptdetail.fkApptTypeId == null) {
      this.ValidateappType = true;
      this.user_validated =
        this.user_validated +
        " " +
        this.authService.appointmentMsg["upgradeMsg.msg36"] +
        " \n";
    }
  }
  validate_mandatoryDOB() {

    if (this.patient_mendatory_fields[0].mandatoryDOB == true) {
      if (this.opdvisitService.apptdetail.dob == null || this.opdvisitService.apptdetail.dob == "") {
        this.validatemandatoryDOB = true;
        this.user_validated = this.user_validated + " " + "DOB, " + " \n";
      }
    }
  }
  validate_DOBAge() {
    if (
      this.opdvisitService.apptdetail.ageYear == null &&
      this.opdvisitService.apptdetail.ageMonth == null &&
      this.opdvisitService.apptdetail.ageDays == null
    ) {
      this.validateDOBAge = true;
      this.user_validated =
        this.user_validated +
        " " +
        this.authService.appointmentMsg["upgradeMsg.msg37"] +
        " \n";
    }
  }
  validate_initial() {
    if (this.patient_mendatory_fields[0].mandatoryInitial == true) {
      if (this.opdvisitService.apptdetail.initial == null || this.opdvisitService.apptdetail.initial == "") {
        //this.user_validated += 1;
        this.validateinitial = true;
        this.user_validated = this.user_validated + " " + "Initial, " + " \n";
      }
      //  this.validate_gender();
    }
  }
  validate_gender() {

    if (
      this.opdvisitService.apptdetail.sex == null ||
      this.opdvisitService.apptdetail.sex == " " ||
      this.opdvisitService.apptdetail.sex == undefined
    ) {
      this.validategender = true;
      this.user_validated = this.user_validated + " " + "GENDER, " + " \n";
    }

  }
  validate_mobile() {
    if (this.patient_mendatory_fields[0].mandatoryMobile == true) {
      if (this.opdvisitService.apptdetail.mobileNo == null) {
        this.validatemobile = true;
        this.user_validated =
          this.user_validated +
          " " +
          this.authService.appointmentMsg["upgradeMsg.msg38"] +
          " \n";
      } else if (
        this.digits_count(Number(this.opdvisitService.apptdetail.mobileNo)) != 10
      ) {
        this.user_validated =
          this.user_validated +
          " " +
          this.authService.appointmentMsg["upgradeMsg.msg39"] +
          " \n";
      }
    }
  }
  validate_takenOn() {
    if (this.opdvisitService.apptdetail.fkTakenOnId == 0) {
      this.validatetakenOn = true;
      this.user_validated =
        this.user_validated +
        " " +
        this.authService.appointmentMsg["upgradeMsg.msg40"] +
        " \n";
    }
  }
  validate_referredby() {
    // if (this.patient_mendatory_fields[0].mandatoryReferredby == true) {
    if (this.opdvisitService.apptdetail.fkRefById == 0) {
      this.validatereferredby = true;
      this.user_validated =
        this.user_validated +
        " " +
        this.authService.appointmentMsg["upgradeMsg.msg41"] +
        " \n";
    }
    // }
  }

  digits_count(n) {
    var count = 0;
    if (n >= 1) ++count;
    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }
    return count;
  }
  validatemobile: boolean = false;
  validateinitial: boolean = false;
  ValidatefirstName: boolean = false;
  ValidatelastName: boolean = false;
  validateDOBAge: boolean = false;
  validatemandatoryDOB: boolean = false;
  validategender: boolean = false;
  ValidateappType: boolean = false;
  validatereferredby: boolean = false;
  validatetakenOn: boolean = false;
  check_validation(type) {
    this.validate_mobile();
    this.Validate_firstName();
    this.validate_mandatoryDOB();
    this.validate_DOBAge();
    this.validate_initial();
    this.validate_gender();
    this.Validate_appType();
    this.Validate_lastName();
    this.validate_referredby();
    this.validate_takenOn();
    if (this.user_validated != "") {
      const newstring = this.user_validated.substring(
        0,
        this.user_validated.length - 2
      );
      this.dashboardService.openSnackBar_regform(
        this.authService.appointmentMsg["upgradeMsg.msg42"] + " " + newstring,
        this.authService.appointmentMsg["Ok"]
      );
      this.user_validated = "";
    } else {
      if (this.opdvisitService.apptdetail.dob != null) {
        this.disabledappointment = false;
        this.validatemobile = false;
        this.ValidatefirstName = false;
        this.ValidatelastName = false;
        this.validateDOBAge = false;
        this.validatemandatoryDOB = false;
        this.validategender = false;
        this.validateinitial = false;
        this.ValidateappType = false;
        this.validatereferredby = false;
        this.validatetakenOn = false;
        // this.checkgender = false;
        if (type == 0) {
          this.saveRescheduleAppt();
        } else if (type == 1) {
          this.saveMultipleAppt();
        }
      } else {
        this.dashboardService.openSnackBar(
          this.authService.appointmentMsg["upgradeMsg.msg43"],
          this.authService.appointmentMsg["Ok"]
        );
      }
    }
  }
  savemultipleArray: any = [];
  saveMultipleAppt() {
    var newmultiplArray = [];
    if (this.savemultipleArray.length > 0) {
      for (var i = 0; i < this.savemultipleArray.length; i++) {
        let newpayload = {
          fkBranchId: this.savemultipleArray[i].branchid,
          regDate: this.opdvisitService.apptdetail.regDate
            ? this.opdvisitService.apptdetail.regDate
            : null,
          regTime: this.opdvisitService.apptdetail.regTime
            ? this.opdvisitService.apptdetail.regTime
            : null,
          initial: this.opdvisitService.apptdetail.initial,
          firstName: this.opdvisitService.apptdetail.firstName,
          lastName: this.opdvisitService.apptdetail.lastName,
          careofType: this.opdvisitService.apptdetail.careofType
            ? this.opdvisitService.apptdetail.careofType
            : "",
          careofName: "",
          dob: this.datePipe.transform(
            this.opdvisitService.apptdetail.dob,
            "yyyy-MM-dd"
          ),
          ageYear: this.opdvisitService.apptdetail.ageYear
            ? this.opdvisitService.apptdetail.ageYear
            : 1,
          ageMonth: this.opdvisitService.apptdetail.ageMonth
            ? this.opdvisitService.apptdetail.ageMonth
            : 0,
          ageDays: this.opdvisitService.apptdetail.ageDays
            ? this.opdvisitService.apptdetail.ageDays
            : 0,
          sex: this.opdvisitService.apptdetail.sex,
          paddress: this.opdvisitService.apptdetail.address
            ? this.opdvisitService.apptdetail.address
            : null,

          fkPcityId: this.opdvisitService.apptdetail.fkCityId
            ? this.opdvisitService.apptdetail.fkCityId
            : null,
          mobileNo: this.opdvisitService.apptdetail.mobileNo,
          emmergencyNo: "",
          emailAddress: this.opdvisitService.apptdetail.emailAddress
            ? this.opdvisitService.apptdetail.emailAddress
            : null,
          isSentSms: null,
          remarks: this.opdvisitService.apptdetail.remarks,
          isActive: "true",
          pkSynchId: null,
          oldregId: null,
          isSap: null,
          fkReferredbyId: this.opdvisitService.apptdetail.fkRefById,
          fkPartyId: null,
          isOldmrnoageupdate: "0",
          fkCategoryId: 1,
          entryFrom: "WebNetram",
          fkIPDID: 0,
          fkReferredbyIdLatest: this.opdvisitService.apptdetail.fkRefById,
          isSentEmail: false,
          fK_CreatedbyID: this.authService.Loggeduser.userid,
          fK_ModifiedByID: null,
          modifiedDateTime: null,
          fK_DoctorId: this.savemultipleArray[i].doctorId,
          fkRegId: this.opdvisitService.apptdetail.fkRegId
            ? this.opdvisitService.apptdetail.fkRegId
            : null,
          address: this.opdvisitService.apptdetail.address
            ? this.opdvisitService.apptdetail.address
            : null,
          apptTime: this.opdvisitService.convertTo24Hour(
            this.savemultipleArray[i].time
          ),
          fkConsultantId: this.savemultipleArray[i].doctorId,
          isVip: null,
          fkTakenOnId: this.opdvisitService.apptdetail.fkTakenOnId,
          fkRefById: this.opdvisitService.apptdetail.fkRefById,
          fkCityId: this.opdvisitService.apptdetail.fkCityId
            ? this.opdvisitService.apptdetail.fkCityId
            : null,
          fkApptTypeId: this.opdvisitService.apptdetail.fkApptTypeId,
          IsEmergencyAppt: false,
          FK_ScheduleTypeId: this.savemultipleArray[i].scheduleTypeId,
          Fk_SpecialityIdModule: this.authService.Loggeduser.specialityId,
          fkServiceId: null,
          pkAppointmentId: 0,
          apptDate: this.datePipe.transform(
            this.savemultipleArray[i].scheduleDate,
            "yyyy-MM-dd"
          ),
          bookingDate: this.datePipe.transform(
            this.savemultipleArray[i].scheduleDate,
            "yyyy-MM-dd"
          ),
          daySrNo: 1,
          fkCity: this.opdvisitService.apptdetail.fkCity,
          isConfirm: "false",
          isCancelled: "false",
          tokenNo: 1,
          fkForBranchId: this.savemultipleArray[i].branchid,
          fkCreatedById: this.authService.Loggeduser.userid,
          contactNo: this.opdvisitService.apptdetail.mobileNo,
          FK_PartyId: null,
        };
        // this.opdvisitService.apptdetail.fkBranchId =this.savemultipleArray[i].branchid;
        // if (this.opdvisitService.apptdetail.ageYear == 0) {
        //   if (this.opdvisitService.apptdetail.ageMonth != 0 || this.opdvisitService.apptdetail.ageMonth != null || this.opdvisitService.apptdetail.ageDays != 0 || this.opdvisitService.apptdetail.ageDays != null) {
        //     this.opdvisitService.apptdetail.ageYear = 1;
        //   }
        // }
        // this.opdvisitService.apptdetail.fkConsultantId=this.savemultipleArray[i].doctorId;
        // this.opdvisitService.apptdetail.isActive = "true";
        // this.opdvisitService.apptdetail.bookingDate = this.datePipe.transform(this.savemultipleArray[i].scheduleDate, "yyyy-MM-dd");
        // this.opdvisitService.apptdetail.daySrNo = 1;
        // this.opdvisitService.apptdetail.fkCity = null;
        // this.opdvisitService.apptdetail.isConfirm = "false";
        // this.opdvisitService.apptdetail.isCancelled = "false";
        // this.opdvisitService.apptdetail.tokenNo = 1;
        // this.opdvisitService.apptdetail.apptTime = this.opdvisitService.convertTo24Hour(this.savemultipleArray[i].time);
        // this.opdvisitService.apptdetail.fkCreatedById = this.authService.Loggeduser.userid.toString();
        // this.opdvisitService.apptdetail.dob = this.datePipe.transform(this.opdvisitService.apptdetail.dob, "yyyy-MM-dd");
        // this.opdvisitService.apptdetail.apptDate =this.datePipe.transform(this.savemultipleArray[i].scheduleDate, "yyyy-MM-dd");
        // this.opdvisitService.apptdetail.contactNo = this.opdvisitService.apptdetail.mobileNo;
        // this.opdvisitService.apptdetail.FK_PartyId = this.opdvisitService.apptdetail.fkPartyId;
        // this.opdvisitService.apptdetail.fkForBranchId = this.savemultipleArray[i].branchid;
        // this.opdvisitService.apptdetail.pkAppointmentId = 0;
        // if (this.opdvisitService.apptdetail.fkServiceId == null || this.opdvisitService.apptdetail.fkServiceId == undefined) {
        //   this.opdvisitService.apptdetail.fkServiceId = 0;
        // }

        newmultiplArray.push(newpayload);
      }

      let payload = {
        InsertMultipleAppointmentDto: newmultiplArray,
      };
      this.dashboardService.subscriptions = this.appservice.InsertMultipleAppointment(payload).pipe(takeUntil(this.destroy$)).subscribe(
        (item) => {
          this.savemultipleArray = [];
          newmultiplArray = [];
          this.opdvisitService.apptdetail = {};
          this.onMainTabSelectionChanged(4);
          this.DoctorCtrl1.setValue(null);
          this.DoctorCtrl2.setValue(null);
          this.DoctorCtrl3.setValue(null);
          this.DoctorCtrl4.setValue(null);
          this.multipleSacheduleArray4 = [];
          this.multipleSacheduleArray3 = [];
          this.multipleSacheduleArray2 = [];
          this.multipleSacheduleArray1 = [];
          this.firstTime = "";
          this.secondTime = "";
          this.thirdTime = "";
          this.fourthTime = "";
          this.selectedDoctorName = "";
          this.selectedDoctorName2 = "";
          this.selectedDoctorName3 = "";
          this.selectedDoctorName4 = "";
          this.radioGroup1Value = '6';
          this.radioGroup2Value = '6';
          this.radioGroup3Value = '6';
          this.radioGroup4Value = '6';

          this.dashboardService.openSnackBar("Record Saved Successfully", "ok");
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "ok");
        }
      );
    }
  }

  letterOnly(event) {
    var charCode = event.keyCode;
    if (
      (charCode > 64 && charCode < 91) ||
      (charCode > 96 && charCode < 123) ||
      charCode == 8 ||
      charCode == 46 ||
      charCode == 32
    )
      return true;
    else return false;
  }
  fill_gender_and_careof(initials: string) {
    this.opdvisitService.apptdetail.initial = initials;
    var selectedinitials;
    for (let initial of this.opdvisitService.initials) {
      if (initial.initialName == initials && initial.sex != " ") {
        selectedinitials = initial;
        this.checkgender = true;
      } else if (initial.initialName == initials && initial.sex == " ") {
        this.checkgender = false;
        selectedinitials = initial;
      }
    }

    // console.log("initials " + initials);
    // var selectedinitials = this.opdvisitService.initials.find(
    //   item => item.pkInitialId == initials
    // );apptdetail
    this.opdvisitService.apptdetail.sex = selectedinitials.sex;
    this.opdvisitService.apptdetail.careofType = selectedinitials.careof;
  }
  //multiple Appointment
  reMovedataAppointment(event) {
    this.disabledappointment = false;
    if (event == "") {
      this.opdvisitService.apptdetail = {};
      this.userSearchData = [];
    }
  }
  userSearchData: any = [];
  searchpatientdata: string = '';
  GetPatientBySearchTypeBy() {

    if (this.searchpatientdata.length > 3) {
      this.dashboardService.subscriptions = this.appservice
        .GetPatientBySearchTypeByValueOrderBy("A", this.searchpatientdata, "ASC").pipe(takeUntil(this.destroy$))
        .subscribe(
          (item) => {
            this.userSearchData = [];
            this.userSearchData = item;
          },
          (err) => {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        );
    }
  }
  rowClicked: number = -1;
  selectdataRow(data, index) {
    if (this.rowClicked === index) {
      this.rowClicked = -1;
      this.opdvisitService.apptdetail = {};
    } else {
      this.opdvisitService.getappdetails(data);
      this.rowClicked = index;
    }
  }

  selectionStartIndex: number;
  selectionEndIndex: number;
  selectedRows: any[] = [];
  onMouseDown(event: MouseEvent, index: number) {
    this.selectionStartIndex = index;
    this.selectionEndIndex = index;
    this.selectRowsInRange(event);
  }
  onMouseUp(event: MouseEvent, index: number) {
    this.selectionEndIndex = index;
    this.selectRowsInRange(event);
  }

  onMouseMove(event: MouseEvent, index: number) {
    if (event.buttons === 1) {
      this.selectionEndIndex = index;
      this.selectRowsInRange(event);
    }
  }
  selectRowsInRange(event) {
    if (
      this.selectionStartIndex === undefined ||
      this.selectionEndIndex === undefined
    ) {
      return;
    }
    const startIndex = Math.min(
      this.selectionStartIndex,
      this.selectionEndIndex
    );
    const endIndex = Math.max(this.selectionStartIndex, this.selectionEndIndex);

    this.selectedRows = [];
    for (let i = startIndex; i <= endIndex; i++) {
      this.selectedRows.push(this.appservice.fullviewArray[i]);
      this.getvalues(
        event,
        this.appservice.fullviewArray[i].appId,
        this.appservice.fullviewArray[i].time,
        this.appservice.fullviewArray[i].isConfirm,
        this.appservice.fullviewArray[i].isCancelled,
        this.appservice.fullviewArray[i].patientName,
        this.appservice.fullviewArray[i].contactNo,
        this.appservice.fullviewArray[i],
        this.appservice.fullviewArray[i].scheduleTypeId)

    }

  }
  subsepecailityArray: any = [];
  subsepecailityControl = new FormControl('');
  filteredsubOptions: Observable<string[]>;
  getSubsepecitry() {
    this.dashboardService.subscriptions = this.billingservice.getSpeciltiyData(0).pipe(takeUntil(this.destroy$)).subscribe((item: any) => {
      this.subsepecailityArray = [];
      if (item.length > 0) {
        this.subsepecailityArray = item.filter(item => item.isActive == true);

      }
      this.getsubControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  subsepecialityName: string;
  Checkinputdrsummery(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.subspeciltyid = 0;
      this.subsepecialityName = null;
      this.GetDoctorAppointmentSu(this.datePipe.transform(this.selectedsummerydate, 'yyyy-MM-dd'), this.datePipe.transform(this.selectedsummerydate, 'yyyy-MM-dd'));
    }
  }
  getsubControl() {
    this.filteredsubOptions = this.subsepecailityControl.valueChanges.pipe(
      startWith(""),
      map(value => value ? this._filter(value || '') : this.subsepecailityArray.slice()),
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.subsepecailityArray.filter(option => option.subSpecialityName.toLowerCase().includes(filterValue));
  }
  drchecklistClicked: any = -1;
  selectedsummerydate: any;
  RefreshDoctorsummery() {
    this.drSummeryallDates = this.getAllDates(moment(this.fromDateDrSummery), moment(this.toDateDrSummery));
    this.drchecklistClicked = 0;
    this.GetDoctorAppointmentSu(this.datePipe.transform(this.drSummeryallDates[0], 'yyyy-MM-dd'), this.datePipe.transform(this.drSummeryallDates[0], 'yyyy-MM-dd'));
    this.selectedsummerydate = this.drSummeryallDates[0];
  }
  selectAPPtDoctor(i, date) {
    if (this.drchecklistClicked === i) {
      // this.drchecklistClicked = -1;
    } else {
      this.drchecklistClicked = i;
      this.GetDoctorAppointmentSu(this.datePipe.transform(date, 'yyyy-MM-dd'), this.datePipe.transform(date, 'yyyy-MM-dd'));
      this.selectedsummerydate = date;
    }
  }
  drSummeryheader: any = [];
  getdrHeader() {
    this.dashboardService.subscriptions = this.appservice.GetNameByType('DRSUMMARYSCHEDULEGROUP').pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.drSummeryheader = [];

      this.drSummeryheader = x;
      console.log(this.drSummeryheader);
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getAllDates(startDate: any, endDate: any) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(startDate);
      startDate = moment(startDate).add(1, "days");
    }
    return date;
  }
  getsubspecilitybyobj(e: any) {
    var val = e.option.value;
    this.subspeciltyid = val.fK_SpecialityId;
    this.subsepecialityName = val.subSpecialityName;
    this.GetDoctorAppointmentSu(this.datePipe.transform(this.selectedsummerydate, 'yyyy-MM-dd'), this.datePipe.transform(this.selectedsummerydate, 'yyyy-MM-dd'));
  }
  doctorsummeryArray: any = [];
  newdataArray: any = [];
  subspeciltyid: number = 0;
  GetDoctorAppointmentSu(fdate, tdate) {
    this.dashboardService.subscriptions = this.appservice.GetDoctorAppointmentSummary(fdate, tdate, this.getBranceId5, this.subspeciltyid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.doctorsummeryArray = [];
      this.newdataArray = [];
      this.doctorsummeryArray = x;
      const groupArr = this.doctorsummeryArray.reduce(
        (r, { doctorName }) => {
          if (!r.some((o) => o.doctorName == doctorName)) {
            r.push({
              doctorName,
              groupItem: this.doctorsummeryArray.filter(
                (v) => v.doctorName == doctorName
              ),
            });
          }
          return r;
        },
        []
      );

      this.newdataArray = groupArr;

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  countschedule(doctorname, checdulename) {

    let countdata = this.doctorsummeryArray.filter(item => item.doctorName.toLowerCase() == doctorname.toLowerCase() && item.scheduleGroup.toLowerCase() == checdulename.toLowerCase());
    if (countdata.length > 0) {
      return countdata[0].total
    } else {
      return 0
    }
  }
  calclatetotal(data) {

    if (data.name == 'Doctor Name') {
      return 'Total Appointment'
    } else if (data.name != 'Doctor Name') {

      const tcount = this.doctorsummeryArray.filter(item => item.scheduleGroup.toLowerCase() == data.name.toLowerCase());
      if (tcount.length > 0) {
        var j = 0
        for (var i = 0; i < tcount.length; i++) {
          j = j + tcount[i].total;

        }
        return j;
      } else {
        return 0
      }

    }
  }

  statusArray: any = [];
  getConusellorStatus() {
    this.appservice.getConuSugeryStatus().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.statusArray = res;
      this.statusArray.push({
      pK_SurgeryStatusId: 0,
      surgeryStatus: 'All'
    });
      this.initializeConsControl();

    const pendingStatus = this.statusArray.find(status => status.surgeryStatus.toLowerCase() =='pending');
    if (pendingStatus) {
      this.appservice.Surgery = pendingStatus.surgeryStatus;
      this.appservice.Surgeryid = pendingStatus.pK_SurgeryStatusId;
      this.consControl.setValue(pendingStatus.surgeryStatus);

    }
    })
  }

  initializeConsControl() {
    this.consControl = new FormControl();
    this.filteredCounArray = this.consControl.valueChanges.pipe(
      startWith(""),
      map((status) =>
        status
          ? this.filterConFunction(status)
          : this.statusArray.slice()
      )
    );
  }

  filterConFunction(name: string): any[] {
    return this.statusArray.filter((status) =>
      status.surgeryStatus.toLowerCase().includes(name.toLowerCase())
    );
  }

  initializeConsDrControl() {
    this.consDrControl = new FormControl();
    this.filteredAdvisedDoctorArray = this.consDrControl.valueChanges.pipe(
      startWith(""),
      map((dr) =>
        dr
          ? this.filterConDrFunction(dr)
          : this.doctorlist.slice()
      )
    );
  }

  filterConDrFunction(name: string): any[] {
    return this.authService.users.filter((dr) =>
      dr.userName.toLowerCase().includes(name.toLowerCase())
    );
  }

  getSMStemplateList: any = [];
  originalData: any = [];
  searchtep: string = '';

  getSMStemplate() {
    this.appservice.getSMSTEMPLATE().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.getSMStemplateList = res;
      this.originalData = res;
    })
  }
smsInput: string = '';
selectedTemplate: any = null;
selectedIndex: number = -1;
  uploadTemplate() {
  if (this.selectedTemplate) {
    this.smsInput = this.selectedTemplate.name;
    this.closeSMSTemplateModalDialog();
  }
}

selectTemplate(item: any,index:number) {
  this.selectedTemplate = item;
  this.selectedIndex = index;
}
  
  onSearchtemp(searchTerm) {
    const lowerSearchTerm = searchTerm.toLowerCase();

    const dataArray = this.originalData;

    if (!lowerSearchTerm) {
      this.getSMStemplateList = this.originalData;
      return;
    }
    const exactMatches = dataArray
      .map((item, index) => ({ ...item, _originalIndex: index }))
      .filter(item =>
        (item.name && item.name.toLowerCase() === lowerSearchTerm));

    const partialMatches = dataArray
      .map((item, index) => ({ ...item, _originalIndex: index }))
      .filter(item =>
        ((item.name && item.name.toLowerCase().includes(lowerSearchTerm))) &&
        !exactMatches.find(m => m._originalIndex === item._originalIndex)
      );
    this.getSMStemplateList = [...exactMatches, ...partialMatches];
  }


  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
  printappointmentrecord() {
    const printContents = document.getElementById('contentapp')?.innerHTML;
    const popupWin = window.open('', '_blank', 'width=800,height=700');
    const styles = `
  <style>
    body {
      margin: 20px;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-size: 10px;
      color: #000;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
    }

    th, td {
      border: 1px solid #999;
      padding: 2px 4px; /* reduce padding */
      text-align: left;
      vertical-align: top;
      font-size: 9px;
      line-height: 1.2;
    }

    th {
      background-color: #e0e0e0;
      white-space: nowrap;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    /* Hide checkbox if any accidentally included */
    input[type="checkbox"], .mat-checkbox, .mat-checkbox-inner-container {
      display: none !important;
    }

    .section {
      margin-bottom: 10px;
    }

    .section-title {
      background-color: #f0f0f0;
      padding: 5px 10px;
      border-left: 4px solid #007bff;
      font-weight: bold;
      font-size: 10px;
    }

    @media print {
      th, td {
        border: 1px solid #555;
        font-size: 9px;
        padding: 2px 4px;
      }

      th {
        background-color: #ccc !important;
      }

      .section-title {
        font-size: 10px;
      }
    }
  </style>
`;


    popupWin?.document.open();
    popupWin?.document.write(`
    <html>
      <head>
        <title>Appointment Record</title>
        ${styles}
      </head>
      <body onload="window.print();">
        ${printContents}
      </body>
    </html>
  `);
    popupWin?.document.close();
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
